import React, { useMemo, useState, useRef, Fragment } from 'react';
import { Package, Users, ShoppingBag, CreditCard, Search, Eye, Edit2, CheckCircle2, XCircle, Download, TrendingUp, AlertTriangle, ShieldAlert, BarChart3, RefreshCw, Ban, Plus, Upload, Layers, Star, DollarSign, Percent, X, Archive, Megaphone, EyeOff, FileText, Video, Link as LinkIcon, Clock, Key, History, Folder, Lock, Unlock, Bell, Trash2, UserCheck, Zap, Cpu, AlertCircle, ChevronDown } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { Pagination } from '../ui/Pagination';
import { initialMarketplaceProducts, initialMarketplaceOrders, initialMarketplaceSellers, initialMarketplacePayouts, initialMarketplaceDisputes, initialMarketplaceReviews, initialMarketplaceNotifications, type MarketplaceProduct } from '../../data/marketplaceMockData';
interface AdminMarketplaceManagerProps {
  success: (msg: string) => void;
}
type TabId = 'products' | 'sellers' | 'orders' | 'payouts' | 'categories' | 'reviews' | 'moderation' | 'disputes' | 'access' | 'analytics' | 'complaints' | 'archive' | 'problems';
const STATUS_OPTIONS = [{
  value: 'all',
  label: 'Все статусы'
}, {
  value: 'active',
  label: 'Активные'
}, {
  value: 'draft',
  label: 'Черновики'
}, {
  value: 'moderation',
  label: 'На модерации'
}, {
  value: 'rejected',
  label: 'Отклонённые'
}, {
  value: 'hidden',
  label: 'Скрытые'
}, {
  value: 'archived',
  label: 'Архив'
}];
const TYPE_OPTIONS = [{
  value: 'all',
  label: 'Все типы'
}, {
  value: 'курс',
  label: 'Курс'
}, {
  value: 'pdf',
  label: 'PDF'
}, {
  value: 'вебинар',
  label: 'Вебинар'
}, {
  value: 'марафон',
  label: 'Марафон'
}, {
  value: 'видеоурок',
  label: 'Видеоурок'
}, {
  value: 'чек-лист',
  label: 'Чек-лист'
}, {
  value: 'закрытый_клуб',
  label: 'Закрытый клуб'
}, {
  value: 'запись',
  label: 'Запись'
}];
const CATEGORIES = [{
  id: 'cat-1',
  name: 'Обучение',
  slug: 'obuchenie',
  productsCount: 2,
  description: 'Курсы и образовательные программы'
}, {
  id: 'cat-2',
  name: 'Практикумы',
  slug: 'praktikumy',
  productsCount: 1,
  description: 'Практические руководства и гайды'
}, {
  id: 'cat-3',
  name: 'Проработка планет',
  slug: 'prorabotka',
  productsCount: 1,
  description: 'Марафоны и курсы по планетам'
}, {
  id: 'cat-4',
  name: 'Финансы',
  slug: 'finansy',
  productsCount: 1,
  description: 'Финансовая астрология'
}, {
  id: 'cat-5',
  name: 'Отношения',
  slug: 'otnosheniya',
  productsCount: 1,
  description: 'Совместимость и синастрия'
}, {
  id: 'cat-6',
  name: 'Профессионалам',
  slug: 'pro',
  productsCount: 1,
  description: 'Для практикующих астрологов'
}, {
  id: 'cat-7',
  name: 'Комьюнити',
  slug: 'community',
  productsCount: 1,
  description: 'Закрытые клубы и группы'
}, {
  id: 'cat-8',
  name: 'Карьера',
  slug: 'kariera',
  productsCount: 1,
  description: 'Профориентация по карте'
}];
const INITIAL_ACCESS_LOG = [{
  id: 'ACC-1',
  userId: 'USR-101',
  userName: 'Ирина В.',
  productId: 'PROD-002',
  productTitle: 'Гайд: Транзит Сатурна',
  type: 'pdf',
  accessStatus: 'granted' as const,
  grantedAt: 'Сегодня, 14:31',
  expiresAt: 'Бессрочно',
  downloads: 2
}, {
  id: 'ACC-2',
  userId: 'USR-102',
  userName: 'Ольга М.',
  productId: 'PROD-001',
  productTitle: 'Основы ведической астрологии',
  type: 'курс',
  accessStatus: 'granted' as const,
  grantedAt: 'Сегодня, 11:16',
  expiresAt: '12 Окт 2025',
  downloads: 0
}, {
  id: 'ACC-3',
  userId: 'USR-105',
  userName: 'Екатерина Н.',
  productId: 'PROD-007',
  productTitle: 'Закрытый клуб: Астро-практика',
  type: 'закрытый_клуб',
  accessStatus: 'pending' as const,
  grantedAt: '—',
  expiresAt: 'Ежемесячно',
  downloads: 0
}, {
  id: 'ACC-4',
  userId: 'USR-104',
  userName: 'Светлана П.',
  productId: 'PROD-003',
  productTitle: 'Марафон: Пробуждение Венеры',
  type: 'марафон',
  accessStatus: 'revoked' as const,
  grantedAt: 'Вчера, 18:20',
  expiresAt: '—',
  downloads: 5
}, {
  id: 'ACC-5',
  userId: 'USR-106',
  userName: 'Алексей Т.',
  productId: 'PROD-006',
  productTitle: 'Видеоурок: Ректификация',
  type: 'видеоурок',
  accessStatus: 'granted' as const,
  grantedAt: 'Вчера, 12:06',
  expiresAt: 'Бессрочно',
  downloads: 1
}, {
  id: 'ACC-6',
  userId: 'USR-107',
  userName: 'Марина Л.',
  productId: 'PROD-002',
  productTitle: 'Гайд: Транзит Сатурна',
  type: 'pdf',
  accessStatus: 'granted' as const,
  grantedAt: '2 дня назад',
  expiresAt: 'Бессрочно',
  downloads: 3
}];
// Mock AI data per product
const AI_PRODUCT_DATA: Record<string, {
  generations: number;
  pdfsGenerated: number;
  errors: number;
  quality: number;
  lastGeneration: string;
  avgTime: string;
}> = {
  'PROD-001': {
    generations: 284,
    pdfsGenerated: 142,
    errors: 3,
    quality: 96,
    lastGeneration: 'Сегодня, 12:45',
    avgTime: '12 сек'
  },
  'PROD-002': {
    generations: 712,
    pdfsGenerated: 356,
    errors: 8,
    quality: 94,
    lastGeneration: 'Сегодня, 14:20',
    avgTime: '5 сек'
  },
  'PROD-003': {
    generations: 178,
    pdfsGenerated: 89,
    errors: 1,
    quality: 98,
    lastGeneration: 'Вчера, 18:30',
    avgTime: '15 сек'
  },
  'PROD-004': {
    generations: 420,
    pdfsGenerated: 210,
    errors: 5,
    quality: 95,
    lastGeneration: 'Сегодня, 09:15',
    avgTime: '8 сек'
  },
  'PROD-006': {
    generations: 90,
    pdfsGenerated: 45,
    errors: 2,
    quality: 92,
    lastGeneration: '3 дня назад',
    avgTime: '20 сек'
  },
  'PROD-007': {
    generations: 60,
    pdfsGenerated: 30,
    errors: 0,
    quality: 99,
    lastGeneration: 'Вчера, 10:00',
    avgTime: '10 сек'
  },
  'PROD-008': {
    generations: 50,
    pdfsGenerated: 25,
    errors: 1,
    quality: 97,
    lastGeneration: 'Сегодня, 11:00',
    avgTime: '18 сек'
  },
  'PROD-009': {
    generations: 0,
    pdfsGenerated: 0,
    errors: 0,
    quality: 0,
    lastGeneration: '—',
    avgTime: '—'
  },
  'PROD-010': {
    generations: 15,
    pdfsGenerated: 8,
    errors: 0,
    quality: 100,
    lastGeneration: 'Вчера',
    avgTime: '7 сек'
  }
};
// Mock ad status per product
const AD_STATUS: Record<string, {
  active: boolean;
  impressions: number;
  clicks: number;
}> = {
  'PROD-001': {
    active: true,
    impressions: 12400,
    clicks: 890
  },
  'PROD-002': {
    active: true,
    impressions: 8200,
    clicks: 620
  },
  'PROD-003': {
    active: false,
    impressions: 0,
    clicks: 0
  },
  'PROD-004': {
    active: true,
    impressions: 5600,
    clicks: 340
  }
};
export function AdminMarketplaceManager({
  success
}: AdminMarketplaceManagerProps) {
  const [activeTab, setActiveTab] = useState<TabId>('products');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [selectedProductId, setSelectedProductId] = useState<string | null>(null);
  const [detailTab, setDetailTab] = useState<'info' | 'content' | 'access' | 'sales' | 'finance' | 'ai' | 'reviews' | 'ads' | 'history'>('info');
  const [kpiFilter, setKpiFilter] = useState<string | null>(null);
  // Pagination states
  const [productsPage, setProductsPage] = useState(1);
  const [sellersPage, setSellersPage] = useState(1);
  const [ordersPage, setOrdersPage] = useState(1);
  const [disputesPage, setDisputesPage] = useState(1);
  const [reviewsPage, setReviewsPage] = useState(1);
  const [accessPage, setAccessPage] = useState(1);
  const PAGE_SIZE_OPTIONS = [20, 50, 100] as const;
  const [pageSize, setPageSize] = useState<number>(20);
  const ITEMS_PER_PAGE = pageSize;
  // Additional filter states
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [astrologerFilter, setAstrologerFilter] = useState('all');
  const [ratingFilter, setRatingFilter] = useState('all');
  // Advanced filter states
  const [salesFilter, setSalesFilter] = useState('all'); // 'all' | 'has_sales' | 'no_sales'
  const [complaintsFilter, setComplaintsFilter] = useState('all'); // 'all' | 'has_complaints'
  const [refundsFilter, setRefundsFilter] = useState('all'); // 'all' | 'has_refunds'
  const [aiFilter, setAiFilter] = useState('all'); // 'all' | 'has_ai'
  const [adFilter, setAdFilter] = useState('all'); // 'all' | 'advertised'
  const [expandedProductRow, setExpandedProductRow] = useState<string | null>(null);
  const toggleProductRow = (id: string) => {
    if (expandedProductRow === id) {
      setExpandedProductRow(null);
      if (selectedProductId === id) setSelectedProductId(null);
    } else {
      setExpandedProductRow(id);
      setSelectedProductId(id);
      setDetailTab('info');
    }
  };
  // Debounced search for performance with 1000+ items
  const [searchInput, setSearchInput] = useState('');
  const searchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleSearchChange = (value: string) => {
    setSearchInput(value);
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setSearchQuery(value);
      resetProductsPage();
    }, 300);
  };
  // Mass actions & create modal
  const [massSelectMode, setMassSelectMode] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState<Set<string>>(new Set());
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newProduct, setNewProduct] = useState({
    title: '',
    type: 'Курс',
    price: '',
    description: '',
    authorName: ''
  });
  const toggleProductSelect = (id: string) => {
    setSelectedProductIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      return next;
    });
  };
  const toggleSelectAll = (visibleProducts: {
    id: string;
  }[]) => {
    if (selectedProductIds.size === visibleProducts.length) {
      setSelectedProductIds(new Set());
    } else {
      setSelectedProductIds(new Set(visibleProducts.map(p => p.id)));
    }
  };
  const handleMassAction = (action: string) => {
    const ids = Array.from(selectedProductIds);
    if (action === 'approve') {
      setProducts(prev => prev.map(p => ids.includes(p.id) ? {
        ...p,
        status: 'active' as const
      } : p));
      success(`${ids.length} товаров одобрено`);
    } else if (action === 'hide') {
      setProducts(prev => prev.map(p => ids.includes(p.id) ? {
        ...p,
        status: 'hidden' as const
      } : p));
      success(`${ids.length} товаров скрыто`);
    } else if (action === 'archive') {
      setProducts(prev => prev.map(p => ids.includes(p.id) ? {
        ...p,
        status: 'archived' as const
      } : p));
      success(`${ids.length} товаров в архив`);
    }
    setSelectedProductIds(new Set());
    setMassSelectMode(false);
  };
  const handleCreateProduct = () => {
    if (!newProduct.title.trim() || !newProduct.price.trim()) return;
    const id = `PROD-${String(products.length + 1).padStart(3, '0')}`;
    const now = new Date().toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
    setProducts(prev => [{
      id,
      title: newProduct.title,
      type: newProduct.type,
      price: `${parseInt(newProduct.price).toLocaleString('ru-RU')} ₽`,
      priceNum: parseInt(newProduct.price) || 0,
      description: newProduct.description || 'Описание товара',
      targetAudience: 'Целевая аудитория',
      whatUserGets: ['Доступ к материалам'],
      authorId: 'ASTR-001',
      authorName: newProduct.authorName || 'Администратор',
      authorAvatar: (newProduct.authorName || 'АД').slice(0, 2).toUpperCase(),
      category: 'Общее',
      status: 'moderation' as const,
      salesCount: 0,
      revenue: '0 ₽',
      rating: 0,
      reviewsCount: 0,
      coverColor: 'bg-indigo-100',
      createdAt: now,
      updatedAt: now,
      items: []
    }, ...prev]);
    setNewProduct({
      title: '',
      type: 'Курс',
      price: '',
      description: '',
      authorName: ''
    });
    setShowCreateModal(false);
    success(`Товар "${newProduct.title}" создан и отправлен на модерацию`);
  };
  // Per-tab search states
  const [sellersSearch, setSellersSearch] = useState('');
  const [ordersSearch, setOrdersSearch] = useState('');
  const [disputesSearch, setDisputesSearch] = useState('');
  const [reviewsSearch, setReviewsSearch] = useState('');
  const [accessSearch, setAccessSearch] = useState('');
  const [products, setProducts] = useState(initialMarketplaceProducts);
  const [orders, setOrders] = useState(initialMarketplaceOrders);
  const [sellers, setSellers] = useState(initialMarketplaceSellers);
  const [payouts, setPayouts] = useState(initialMarketplacePayouts);
  const [disputes, setDisputes] = useState(initialMarketplaceDisputes);
  const [reviews, setReviews] = useState(initialMarketplaceReviews);
  const [notifications] = useState(initialMarketplaceNotifications);
  const [accessLog, setAccessLog] = useState(INITIAL_ACCESS_LOG);
  const [categories, setCategories] = useState(CATEGORIES);
  // Computed KPIs - EXPANDED
  const kpis = useMemo(() => {
    const active = products.filter(p => p.status === 'active').length;
    const onMod = products.filter(p => p.status === 'moderation').length;
    const hidden = products.filter(p => p.status === 'hidden').length;
    const archived = products.filter(p => p.status === 'archived').length;
    const totalSales = products.reduce((s, p) => s + p.salesCount, 0);
    const totalRevenue = orders.reduce((s, o) => s + o.priceNum, 0);
    const platformIncome = orders.reduce((s, o) => s + parseInt(o.commissionAmount.replace(/[^\d]/g, '') || '0'), 0);
    const avgCheck = totalSales > 0 ? Math.round(totalRevenue / totalSales) : 0;
    const refunds = orders.filter(o => o.status === 'refunded').length;
    const openDisputes = disputes.filter(d => d.status === 'open' || d.status === 'in_review').length;
    const totalAccess = accessLog.filter(a => a.accessStatus === 'granted').length;
    const aiProducts = products.filter(p => AI_PRODUCT_DATA[p.id] && AI_PRODUCT_DATA[p.id].generations > 0).length;
    const noSales = products.filter(p => p.status === 'active' && p.salesCount === 0).length;
    const problemProducts = products.filter(p => {
      const pDisputes = disputes.filter(d => d.productId === p.id && (d.status === 'open' || d.status === 'in_review'));
      const pRefunds = orders.filter(o => o.productId === p.id && o.status === 'refunded');
      return p.rating > 0 && p.rating < 3.5 || pDisputes.length > 0 || pRefunds.length > 0;
    }).length;
    const conversion = 8.2;
    return {
      total: products.length,
      active,
      onMod,
      hidden,
      archived,
      totalRevenue,
      platformIncome,
      totalSales,
      avgCheck,
      refunds,
      openDisputes,
      totalAccess,
      aiProducts,
      noSales,
      problemProducts,
      conversion
    };
  }, [products, orders, disputes, accessLog]);
  // Filtered products - ENHANCED with all KPI filters and advanced filters
  const filteredProducts = useMemo(() => {
    let list = [...products];
    // Standard filters
    if (statusFilter !== 'all') list = list.filter(p => p.status === statusFilter);
    if (typeFilter !== 'all') list = list.filter(p => p.type === typeFilter);
    if (categoryFilter !== 'all') list = list.filter(p => p.category === categoryFilter);
    if (astrologerFilter !== 'all') list = list.filter(p => p.authorId === astrologerFilter);
    if (ratingFilter !== 'all') {
      const minRating = parseFloat(ratingFilter);
      list = list.filter(p => p.rating >= minRating);
    }
    // Advanced filters
    if (salesFilter === 'has_sales') list = list.filter(p => p.salesCount > 0);else if (salesFilter === 'no_sales') list = list.filter(p => p.salesCount === 0);
    if (complaintsFilter === 'has_complaints') list = list.filter(p => disputes.some(d => d.productId === p.id));
    if (refundsFilter === 'has_refunds') list = list.filter(p => orders.some(o => o.productId === p.id && o.status === 'refunded'));
    if (aiFilter === 'has_ai') list = list.filter(p => AI_PRODUCT_DATA[p.id] && AI_PRODUCT_DATA[p.id].generations > 0);
    if (adFilter === 'advertised') list = list.filter(p => AD_STATUS[p.id]?.active);
    // Search
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      list = list.filter(p => p.title.toLowerCase().includes(q) || p.id.toLowerCase().includes(q) || p.authorName.toLowerCase().includes(q));
    }
    return list;
  }, [products, statusFilter, typeFilter, categoryFilter, astrologerFilter, ratingFilter, salesFilter, complaintsFilter, refundsFilter, aiFilter, adFilter, searchQuery, disputes, orders]);
  // Reset page on filter change
  const resetProductsPage = () => setProductsPage(1);
  const selectedProduct = selectedProductId ? products.find(p => p.id === selectedProductId) : null;
  // Filtered per-tab data
  const filteredSellers = useMemo(() => {
    if (!sellersSearch.trim()) return sellers;
    const q = sellersSearch.toLowerCase();
    return sellers.filter(s => s.name.toLowerCase().includes(q) || s.email.toLowerCase().includes(q) || s.id.toLowerCase().includes(q));
  }, [sellers, sellersSearch]);
  const filteredOrders = useMemo(() => {
    if (!ordersSearch.trim()) return orders;
    const q = ordersSearch.toLowerCase();
    return orders.filter(o => o.id.toLowerCase().includes(q) || o.buyerName.toLowerCase().includes(q) || o.productTitle.toLowerCase().includes(q) || o.sellerName.toLowerCase().includes(q));
  }, [orders, ordersSearch]);
  const filteredDisputes = useMemo(() => {
    if (!disputesSearch.trim()) return disputes;
    const q = disputesSearch.toLowerCase();
    return disputes.filter(d => d.id.toLowerCase().includes(q) || d.buyerName.toLowerCase().includes(q) || d.sellerName.toLowerCase().includes(q) || d.productTitle.toLowerCase().includes(q));
  }, [disputes, disputesSearch]);
  const filteredReviews = useMemo(() => {
    if (!reviewsSearch.trim()) return reviews;
    const q = reviewsSearch.toLowerCase();
    return reviews.filter(r => r.buyerName.toLowerCase().includes(q) || r.productTitle.toLowerCase().includes(q) || r.text.toLowerCase().includes(q));
  }, [reviews, reviewsSearch]);
  const filteredAccess = useMemo(() => {
    if (!accessSearch.trim()) return accessLog;
    const q = accessSearch.toLowerCase();
    return accessLog.filter(a => a.userName.toLowerCase().includes(q) || a.productTitle.toLowerCase().includes(q) || a.userId.toLowerCase().includes(q));
  }, [accessLog, accessSearch]);
  // Helper: problem detection
  const getProductProblems = (p: MarketplaceProduct) => {
    const pOrders = orders.filter(o => o.productId === p.id);
    const pDisputes = disputes.filter(d => d.productId === p.id && (d.status === 'open' || d.status === 'in_review'));
    const refunds = pOrders.filter(o => o.status === 'refunded').length;
    const problems: string[] = [];
    if (p.rating > 0 && p.rating < 3.5) problems.push(`Рейтинг ${p.rating}`);
    if (pDisputes.length > 0) problems.push(`${pDisputes.length} спор(ов)`);
    if (refunds > 0) problems.push(`${refunds} возврат(ов)`);
    return problems;
  };
  // Helper: money status
  const getMoneyStatus = (p: MarketplaceProduct): {
    icon: string;
    label: string;
    color: string;
  } => {
    if (p.status !== 'active') return {
      icon: '⏸',
      label: 'Неактивен',
      color: 'text-slate-400'
    };
    if (p.salesCount >= 50) return {
      icon: '💰',
      label: 'Зарабатывает',
      color: 'text-emerald-600'
    };
    if (p.salesCount >= 10) return {
      icon: '⚠️',
      label: 'Мало продаж',
      color: 'text-amber-600'
    };
    if (p.salesCount > 0) return {
      icon: '📉',
      label: 'Слабые продажи',
      color: 'text-orange-500'
    };
    return {
      icon: '❌',
      label: 'Не продаётся',
      color: 'text-rose-500'
    };
  };
  // Helper: access count per product
  const getAccessCount = (productId: string) => {
    return accessLog.filter(a => a.productId === productId && a.accessStatus === 'granted').length;
  };
  // Handlers
  const changeStatus = (id: string, status: MarketplaceProduct['status'], msg: string) => {
    setProducts(products.map(p => p.id === id ? {
      ...p,
      status
    } : p));
    success(msg);
  };
  const handleApprovePayout = (id: string) => {
    setPayouts(payouts.map(p => p.id === id ? {
      ...p,
      status: 'paid_out' as const
    } : p));
    success(`Выплата ${id} проведена`);
  };
  const handleRetryPayout = (id: string) => {
    setPayouts(payouts.map(p => p.id === id ? {
      ...p,
      status: 'pending' as const
    } : p));
    success(`Выплата ${id} на повтор`);
  };
  const handleResolveDispute = (id: string, resolution: 'resolved_buyer' | 'resolved_seller') => {
    setDisputes(disputes.map(d => d.id === id ? {
      ...d,
      status: resolution,
      resolvedAt: 'Только что'
    } : d));
    success(`Спор ${id} решен`);
  };
  const handleRefundOrder = (id: string) => {
    setOrders(orders.map(o => o.id === id ? {
      ...o,
      status: 'refunded' as const,
      accessStatus: 'revoked' as const
    } : o));
    success(`Возврат по ${id}`);
  };
  const handleBlockSeller = (id: string) => {
    setSellers(sellers.map(s => s.id === id ? {
      ...s,
      status: 'blocked' as const
    } : s));
    success(`Продавец ${id} заблокирован`);
  };
  const handleUnblockSeller = (id: string) => {
    setSellers(sellers.map(s => s.id === id ? {
      ...s,
      status: 'active' as const
    } : s));
    success(`Продавец ${id} разблокирован`);
  };
  const handleReviewAction = (id: string, action: 'published' | 'hidden') => {
    setReviews(reviews.map(r => r.id === id ? {
      ...r,
      status: action
    } : r));
    success(`Отзыв ${id} ${action === 'published' ? 'опубликован' : 'скрыт'}`);
  };
  const handleRevokeAccess = (id: string) => {
    setAccessLog(accessLog.map(a => a.id === id ? {
      ...a,
      accessStatus: 'revoked' as const
    } : a));
    success(`Доступ ${id} отозван`);
  };
  const handleGrantAccess = (id: string) => {
    setAccessLog(accessLog.map(a => a.id === id ? {
      ...a,
      accessStatus: 'granted' as const,
      grantedAt: 'Только что'
    } : a));
    success(`Доступ ${id} открыт`);
  };
  const handleDeleteCategory = (id: string, name: string) => {
    setCategories(categories.filter(c => c.id !== id));
    success(`Категория "${name}" удалена`);
  };
  // Status badge
  const renderStatusBadge = (status: string) => {
    const map: Record<string, {
      variant: 'success' | 'warning' | 'error' | 'neutral';
      label: string;
    }> = {
      active: {
        variant: 'success',
        label: 'Активен'
      },
      access_granted: {
        variant: 'success',
        label: 'Доступ открыт'
      },
      paid_out: {
        variant: 'success',
        label: 'Выплачено'
      },
      published: {
        variant: 'success',
        label: 'Опубликован'
      },
      sent: {
        variant: 'success',
        label: 'Отправлено'
      },
      paid: {
        variant: 'success',
        label: 'Оплачен'
      },
      granted: {
        variant: 'success',
        label: 'Открыт'
      },
      moderation: {
        variant: 'warning',
        label: 'На модерации'
      },
      pending_payment: {
        variant: 'warning',
        label: 'Ожидает оплаты'
      },
      pending: {
        variant: 'warning',
        label: 'Ожидает'
      },
      open: {
        variant: 'warning',
        label: 'Открыт'
      },
      in_review: {
        variant: 'warning',
        label: 'На рассмотрении'
      },
      rejected: {
        variant: 'error',
        label: 'Отклонён'
      },
      canceled: {
        variant: 'error',
        label: 'Отменён'
      },
      failed: {
        variant: 'error',
        label: 'Ошибка'
      },
      blocked: {
        variant: 'error',
        label: 'Заблокирован'
      },
      revoked: {
        variant: 'error',
        label: 'Отозван'
      },
      disputed: {
        variant: 'error',
        label: 'Спор'
      },
      restricted: {
        variant: 'error',
        label: 'Ограничен'
      },
      draft: {
        variant: 'neutral',
        label: 'Черновик'
      },
      hidden: {
        variant: 'neutral',
        label: 'Скрыт'
      },
      archived: {
        variant: 'neutral',
        label: 'Архив'
      },
      closed: {
        variant: 'neutral',
        label: 'Закрыт'
      },
      refunded: {
        variant: 'neutral',
        label: 'Возврат'
      },
      resolved_buyer: {
        variant: 'success',
        label: 'Решен (Покупатель)'
      },
      resolved_seller: {
        variant: 'success',
        label: 'Решен (Продавец)'
      }
    };
    const m = map[status] || {
      variant: 'neutral' as const,
      label: status
    };
    return <Badge variant={m.variant} size="sm" data-id="element-4800">
        {m.label}
      </Badge>;
  };
  const iconBtn = (icon: React.ReactNode, title: string, onClick: () => void, color = 'text-slate-400 hover:text-indigo-600 hover:bg-indigo-50') => <button onClick={onClick} className={`p-1.5 ${color} rounded-lg transition-colors`} title={title} data-id="element-4801">
      {icon}
    </button>;
  // ========== KPI ROW - EXPANDED ==========
  const renderKpiRow = () => {
    const kpiCards = [{
      key: null,
      label: 'Всего',
      value: kpis.total,
      icon: <Package className="w-3.5 h-3.5" data-id="element-4802" />,
      bg: 'bg-indigo-50',
      fg: 'text-indigo-600'
    }, {
      key: 'active',
      label: 'Активные',
      value: kpis.active,
      icon: <CheckCircle2 className="w-3.5 h-3.5" data-id="element-4803" />,
      bg: 'bg-emerald-50',
      fg: 'text-emerald-600'
    }, {
      key: 'moderation',
      label: 'Модерация',
      value: kpis.onMod,
      icon: <ShieldAlert className="w-3.5 h-3.5" data-id="element-4804" />,
      bg: 'bg-amber-50',
      fg: 'text-amber-600'
    }, {
      key: 'hidden',
      label: 'Скрытые',
      value: kpis.hidden,
      icon: <EyeOff className="w-3.5 h-3.5" data-id="element-4805" />,
      bg: 'bg-slate-100',
      fg: 'text-slate-500'
    }, {
      key: null,
      label: 'Доход',
      value: `${kpis.totalRevenue.toLocaleString('ru-RU')} ₽`,
      icon: <DollarSign className="w-3.5 h-3.5" data-id="element-4806" />,
      bg: 'bg-blue-50',
      fg: 'text-blue-600'
    }, {
      key: null,
      label: 'Платформа',
      value: `${kpis.platformIncome.toLocaleString('ru-RU')} ₽`,
      icon: <Percent className="w-3.5 h-3.5" data-id="element-4807" />,
      bg: 'bg-violet-50',
      fg: 'text-violet-600'
    }, {
      key: null,
      label: 'Продажи',
      value: kpis.totalSales,
      icon: <ShoppingBag className="w-3.5 h-3.5" data-id="element-4808" />,
      bg: 'bg-sky-50',
      fg: 'text-sky-600'
    }, {
      key: null,
      label: 'Ср. чек',
      value: `${kpis.avgCheck.toLocaleString('ru-RU')} ₽`,
      icon: <TrendingUp className="w-3.5 h-3.5" data-id="element-4809" />,
      bg: 'bg-teal-50',
      fg: 'text-teal-600'
    }, {
      key: 'refunds',
      label: 'Возвраты',
      value: kpis.refunds,
      icon: <RefreshCw className="w-3.5 h-3.5" data-id="element-4810" />,
      bg: 'bg-rose-50',
      fg: 'text-rose-600'
    }, {
      key: 'disputes',
      label: 'Споры',
      value: kpis.openDisputes,
      icon: <AlertTriangle className="w-3.5 h-3.5" data-id="element-4811" />,
      bg: 'bg-orange-50',
      fg: 'text-orange-600'
    }, {
      key: null,
      label: 'Доступы',
      value: kpis.totalAccess,
      icon: <Key className="w-3.5 h-3.5" data-id="element-4812" />,
      bg: 'bg-cyan-50',
      fg: 'text-cyan-600'
    }, {
      key: 'ai_products',
      label: 'AI',
      value: kpis.aiProducts,
      icon: <Zap className="w-3.5 h-3.5" data-id="element-4813" />,
      bg: 'bg-purple-50',
      fg: 'text-purple-600'
    }, {
      key: 'no_sales',
      label: 'Без продаж',
      value: kpis.noSales,
      icon: <XCircle className="w-3.5 h-3.5" data-id="element-4814" />,
      bg: 'bg-gray-50',
      fg: 'text-gray-500'
    }, {
      key: 'problems',
      label: 'Проблемные',
      value: kpis.problemProducts,
      icon: <AlertCircle className="w-3.5 h-3.5" data-id="element-4815" />,
      bg: kpis.problemProducts > 0 ? 'bg-red-50' : 'bg-slate-50',
      fg: kpis.problemProducts > 0 ? 'text-red-600' : 'text-slate-400'
    }];
    return <div className="overflow-x-auto scrollbar-hide -mx-1 px-1" data-id="element-4816">
        <div className="flex gap-2 min-w-max pb-1" data-id="element-4817">
          {kpiCards.map((kpi, i) => <div key={i} className="text-left px-3 py-2 rounded-lg border border-slate-200 bg-white flex items-center gap-2.5 min-w-[120px]" data-id="element-4818">
              <div className={`w-7 h-7 rounded-lg ${kpi.bg} ${kpi.fg} flex items-center justify-center flex-shrink-0`} data-id="element-4819">
                {kpi.icon}
              </div>
              <div className="min-w-0" data-id="element-4820">
                <div className="text-[10px] text-slate-500 font-medium leading-tight truncate" data-id="element-4821">
                  {kpi.label}
                </div>
                <div className="text-sm font-bold text-slate-900 leading-tight" data-id="element-4822">
                  {kpi.value}
                </div>
              </div>
            </div>)}
        </div>
      </div>;
  };
  // ========== PRODUCT DETAIL PANEL (ENHANCED) ==========
  const renderProductDetail = () => {
    if (!selectedProduct) return null;
    const productOrders = orders.filter(o => o.productId === selectedProduct.id);
    const productReviews = reviews.filter(r => r.productId === selectedProduct.id);
    const productAccess = accessLog.filter(a => a.productId === selectedProduct.id);
    const productDisputes = disputes.filter(d => d.productId === selectedProduct.id);
    const totalRev = productOrders.reduce((s, o) => s + o.priceNum, 0);
    const totalComm = productOrders.reduce((s, o) => s + parseInt(o.commissionAmount.replace(/[^\d]/g, '') || '0'), 0);
    const refundCount = productOrders.filter(o => o.status === 'refunded').length;
    const aiData = AI_PRODUCT_DATA[selectedProduct.id];
    const adData = AD_STATUS[selectedProduct.id];
    const problems = getProductProblems(selectedProduct);
    const moneyStatus = getMoneyStatus(selectedProduct);
    return <div className="p-5 max-h-[420px] overflow-y-auto" data-id="element-4823">
        {detailTab === 'info' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4824">
            <div className="space-y-4" data-id="element-4825">
              <div data-id="element-4826">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4827">
                  Название
                </span>
                <div className="text-sm font-medium text-slate-900" data-id="element-4828">
                  {selectedProduct.title}
                </div>
              </div>
              <div data-id="element-4829">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4830">
                  Описание
                </span>
                <div className="text-sm text-slate-700" data-id="element-4831">
                  {selectedProduct.description}
                </div>
              </div>
              <div data-id="element-4832">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4833">
                  Целевая аудитория
                </span>
                <div className="text-sm text-slate-700" data-id="element-4834">
                  {selectedProduct.targetAudience}
                </div>
              </div>
              <div data-id="element-4835">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4836">
                  Что получит пользователь
                </span>
                <ul className="mt-1 space-y-1" data-id="element-4837">
                  {selectedProduct.whatUserGets.map((w, i) => <li key={i} className="text-sm text-slate-700 flex items-center gap-2" data-id="element-4838">
                      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-4839" />
                      {w}
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="space-y-4" data-id="element-4840">
              {problems.length > 0 && <div className="p-3 bg-rose-50 rounded-lg border border-rose-200" data-id="element-4841">
                  <div className="text-xs font-bold text-rose-700 flex items-center gap-1 mb-1" data-id="element-4842">
                    <AlertCircle className="w-3.5 h-3.5" data-id="element-4843" /> Проблемы
                  </div>
                  <div className="text-sm text-rose-600" data-id="element-4844">
                    {problems.join(' • ')}
                  </div>
                </div>}
              <div className="grid grid-cols-2 gap-3" data-id="element-4845">
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4846">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4847">
                    Тип
                  </span>
                  <div className="text-sm font-medium text-slate-900 capitalize mt-0.5" data-id="element-4848">
                    {selectedProduct.type}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4849">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4850">
                    Категория
                  </span>
                  <div className="text-sm font-medium text-slate-900 mt-0.5" data-id="element-4851">
                    {selectedProduct.category}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4852">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4853">
                    Цена
                  </span>
                  <div className="text-sm font-bold text-indigo-600 mt-0.5" data-id="element-4854">
                    {selectedProduct.price}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4855">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4856">
                    Статус
                  </span>
                  <div className="mt-1" data-id="element-4857">
                    {renderStatusBadge(selectedProduct.status)}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4858">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4859">
                    Доступы
                  </span>
                  <div className="text-sm font-bold text-slate-900 mt-0.5" data-id="element-4860">
                    {productAccess.filter(a => a.accessStatus === 'granted').length}{' '}
                    активных
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4861">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4862">
                    Денежный статус
                  </span>
                  <div className={`text-sm font-medium mt-0.5 ${moneyStatus.color}`} data-id="element-4863">
                    {moneyStatus.icon} {moneyStatus.label}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4864">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4865">
                    Создан
                  </span>
                  <div className="text-sm text-slate-700 mt-0.5" data-id="element-4866">
                    {selectedProduct.createdAt}
                  </div>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4867">
                  <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4868">
                    Обновлён
                  </span>
                  <div className="text-sm text-slate-700 mt-0.5" data-id="element-4869">
                    {selectedProduct.updatedAt}
                  </div>
                </div>
              </div>
              <div className="flex gap-2 pt-2" data-id="element-4870">
                <Button size="sm" variant="primary" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => changeStatus(selectedProduct.id, 'active', `${selectedProduct.id} одобрен`)} data-id="element-4871">
                  ✅ Одобрить
                </Button>
                <Button size="sm" variant="outline" className="text-rose-600 border-rose-200" onClick={() => changeStatus(selectedProduct.id, 'rejected', `${selectedProduct.id} отклонён`)} data-id="element-4872">
                  ❌ Отклонить
                </Button>
                <Button size="sm" variant="outline" onClick={() => changeStatus(selectedProduct.id, 'archived', `${selectedProduct.id} в архив`)} data-id="element-4873">
                  🗑 Архив
                </Button>
              </div>
            </div>
          </div>}

        {detailTab === 'content' && <div className="space-y-4" data-id="element-4874">
            <div className="flex items-center justify-between" data-id="element-4875">
              <h4 className="font-bold text-slate-900" data-id="element-4876">
                Состав товара ({selectedProduct.items?.length || 0} элементов)
              </h4>
              <Button size="sm" variant="outline" icon={<Plus className="w-3.5 h-3.5" data-id="element-4878" />} onClick={() => success('Добавить элемент в состав')} data-id="element-4877">
                Добавить
              </Button>
            </div>
            {/* Summary badges */}
            {selectedProduct.items && selectedProduct.items.length > 0 && <div className="flex flex-wrap gap-1.5" data-id="element-4879">
                {(() => {
            const types = selectedProduct.items.reduce((acc, item) => {
              acc[item.type] = (acc[item.type] || 0) + 1;
              return acc;
            }, {} as Record<string, number>);
            const typeConfig: Record<string, {
              label: string;
              bg: string;
            }> = {
              pdf: {
                label: 'PDF',
                bg: 'bg-rose-100 text-rose-700'
              },
              video: {
                label: 'Видео',
                bg: 'bg-indigo-100 text-indigo-700'
              },
              consultation: {
                label: 'Консультация',
                bg: 'bg-amber-100 text-amber-700'
              },
              bonus: {
                label: 'Бонус',
                bg: 'bg-emerald-100 text-emerald-700'
              },
              checklist: {
                label: 'Чек-лист',
                bg: 'bg-cyan-100 text-cyan-700'
              },
              module: {
                label: 'Модуль',
                bg: 'bg-purple-100 text-purple-700'
              },
              audio: {
                label: 'Аудио',
                bg: 'bg-orange-100 text-orange-700'
              },
              file: {
                label: 'Файл',
                bg: 'bg-slate-100 text-slate-700'
              }
            };
            return Object.entries(types).map(([type, count]) => <span key={type} className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${typeConfig[type]?.bg || 'bg-slate-100 text-slate-600'}`} data-id="element-4880">
                      {typeConfig[type]?.label || type} × {count}
                    </span>);
          })()}
                {selectedProduct.items.some(i => i.type === 'consultation') && <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-amber-50 text-amber-600 border border-amber-200" data-id="element-4881">
                    ⚡ Включает консультацию
                  </span>}
              </div>}
            {/* Items list */}
            {!selectedProduct.items || selectedProduct.items.length === 0 ? <div className="text-sm text-slate-500 p-6 bg-slate-50 rounded-lg text-center" data-id="element-4882">
                <Package className="w-8 h-8 text-slate-300 mx-auto mb-2" data-id="element-4883" />
                Состав товара пуст. Добавьте PDF, видео, бонусы или
                консультацию.
              </div> : <div className="space-y-2" data-id="element-4884">
                {[...selectedProduct.items].sort((a, b) => a.sortOrder - b.sortOrder).map((item, i) => {
            const iconMap: Record<string, {
              icon: React.ReactNode;
              color: string;
              bg: string;
            }> = {
              pdf: {
                icon: <FileText className="w-4 h-4" data-id="element-4885" />,
                color: 'text-rose-500',
                bg: 'bg-rose-50'
              },
              video: {
                icon: <Video className="w-4 h-4" data-id="element-4886" />,
                color: 'text-indigo-500',
                bg: 'bg-indigo-50'
              },
              consultation: {
                icon: <Users className="w-4 h-4" data-id="element-4887" />,
                color: 'text-amber-600',
                bg: 'bg-amber-50'
              },
              bonus: {
                icon: <Zap className="w-4 h-4" data-id="element-4888" />,
                color: 'text-emerald-500',
                bg: 'bg-emerald-50'
              },
              checklist: {
                icon: <CheckCircle2 className="w-4 h-4" data-id="element-4889" />,
                color: 'text-cyan-500',
                bg: 'bg-cyan-50'
              },
              module: {
                icon: <Layers className="w-4 h-4" data-id="element-4890" />,
                color: 'text-purple-500',
                bg: 'bg-purple-50'
              },
              audio: {
                icon: <Bell className="w-4 h-4" data-id="element-4891" />,
                color: 'text-orange-500',
                bg: 'bg-orange-50'
              },
              file: {
                icon: <Download className="w-4 h-4" data-id="element-4892" />,
                color: 'text-slate-500',
                bg: 'bg-slate-50'
              }
            };
            const cfg = iconMap[item.type] || iconMap.file;
            const accessLabel: Record<string, string> = {
              download: 'Скачать',
              stream: 'Смотреть',
              booking: 'Записаться',
              link: 'Ссылка'
            };
            const isConsultation = item.type === 'consultation';
            return <div key={item.id} className={`p-3 rounded-lg border ${isConsultation ? 'border-amber-200 bg-amber-50/30' : 'border-slate-100 bg-slate-50'}`} data-id="element-4893">
                        <div className="flex items-start justify-between gap-3" data-id="element-4894">
                          <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-4895">
                            <div className={`w-8 h-8 rounded-lg ${cfg.bg} ${cfg.color} flex items-center justify-center flex-shrink-0 mt-0.5`} data-id="element-4896">
                              {cfg.icon}
                            </div>
                            <div className="min-w-0 flex-1" data-id="element-4897">
                              <div className="flex items-center gap-2" data-id="element-4898">
                                <span className="text-sm font-medium text-slate-900 truncate" data-id="element-4899">
                                  {item.title}
                                </span>
                                <span className={`text-[9px] font-semibold px-1.5 py-0.5 rounded ${isConsultation ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-4900">
                                  {item.type.toUpperCase()}
                                </span>
                              </div>
                              {item.description && <div className="text-xs text-slate-500 mt-0.5 line-clamp-1" data-id="element-4901">
                                  {item.description}
                                </div>}
                              <div className="flex items-center gap-3 mt-1.5" data-id="element-4902">
                                {item.fileSize && <span className="text-[10px] text-slate-400" data-id="element-4903">
                                    {item.fileSize}
                                  </span>}
                                <span className="text-[10px] text-slate-400" data-id="element-4904">
                                  Доступ:{' '}
                                  {accessLabel[item.accessType] || item.accessType}
                                </span>
                                <span className={`text-[10px] font-medium ${item.status === 'ready' ? 'text-emerald-500' : item.status === 'processing' ? 'text-amber-500' : 'text-slate-400'}`} data-id="element-4905">
                                  {item.status === 'ready' ? '● Готов' : item.status === 'processing' ? '◐ Обработка' : '○ Ожидает'}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-0.5 flex-shrink-0" data-id="element-4906">
                            {iconBtn(<Edit2 className="w-3.5 h-3.5" data-id="element-4907" />, 'Редактировать', () => success(`Редактирование ${item.id}`))}
                            {iconBtn(<Trash2 className="w-3.5 h-3.5" data-id="element-4908" />, 'Удалить', () => success(`Удаление ${item.id}`), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                          </div>
                        </div>
                      </div>;
          })}
              </div>}
            {/* What user gets */}
            {selectedProduct.whatUserGets.length > 0 && <div className="mt-4 p-3 bg-indigo-50/50 rounded-lg border border-indigo-100" data-id="element-4909">
                <div className="text-[10px] text-indigo-600 font-semibold uppercase mb-2" data-id="element-4910">
                  Что получит покупатель
                </div>
                <div className="space-y-1" data-id="element-4911">
                  {selectedProduct.whatUserGets.map((item, i) => <div key={i} className="flex items-center gap-2 text-xs text-slate-700" data-id="element-4912">
                      <CheckCircle2 className="w-3 h-3 text-indigo-400 flex-shrink-0" data-id="element-4913" />
                      {item}
                    </div>)}
                </div>
              </div>}
          </div>}

        {detailTab === 'access' && <div className="space-y-4" data-id="element-4914">
            <div className="grid grid-cols-4 gap-3" data-id="element-4915">
              <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-100" data-id="element-4916">
                <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4917">
                  Активных
                </span>
                <div className="text-xl font-bold text-emerald-700 mt-1" data-id="element-4918">
                  {productAccess.filter(a => a.accessStatus === 'granted').length}
                </div>
              </div>
              <div className="p-3 bg-amber-50 rounded-lg border border-amber-100" data-id="element-4919">
                <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4920">
                  Ожидают
                </span>
                <div className="text-xl font-bold text-amber-700 mt-1" data-id="element-4921">
                  {productAccess.filter(a => a.accessStatus === 'pending').length}
                </div>
              </div>
              <div className="p-3 bg-rose-50 rounded-lg border border-rose-100" data-id="element-4922">
                <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4923">
                  Отозвано
                </span>
                <div className="text-xl font-bold text-rose-700 mt-1" data-id="element-4924">
                  {productAccess.filter(a => a.accessStatus === 'revoked').length}
                </div>
              </div>
              <div className="p-3 bg-slate-50 rounded-lg" data-id="element-4925">
                <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-4926">
                  Тип доступа
                </span>
                <div className="text-sm font-medium text-slate-900 mt-1" data-id="element-4927">
                  {selectedProduct.type === 'закрытый_клуб' ? 'Подписка' : 'Бессрочный'}
                </div>
              </div>
            </div>
            {productAccess.length > 0 ? <div className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-4928">
                <table className="w-full text-left text-sm" data-id="element-4929">
                  <thead className="bg-slate-50 text-slate-500 text-xs border-b border-slate-200" data-id="element-4930">
                    <tr data-id="element-4931">
                      <th className="px-3 py-2 font-medium" data-id="element-4932">Пользователь</th>
                      <th className="px-3 py-2 font-medium" data-id="element-4933">Статус</th>
                      <th className="px-3 py-2 font-medium" data-id="element-4934">Выдан</th>
                      <th className="px-3 py-2 font-medium" data-id="element-4935">Истекает</th>
                      <th className="px-3 py-2 font-medium" data-id="element-4936">Скачиваний</th>
                      <th className="px-3 py-2 font-medium text-right" data-id="element-4937">
                        Действия
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100" data-id="element-4938">
                    {productAccess.map(a => <tr key={a.id} className="hover:bg-slate-50" data-id="element-4939">
                        <td className="px-3 py-2" data-id="element-4940">
                          <div className="font-medium text-xs text-slate-900" data-id="element-4941">
                            {a.userName}
                          </div>
                          <div className="text-[10px] text-slate-500" data-id="element-4942">
                            {a.userId}
                          </div>
                        </td>
                        <td className="px-3 py-2" data-id="element-4943">
                          {renderStatusBadge(a.accessStatus)}
                        </td>
                        <td className="px-3 py-2 text-xs text-slate-500" data-id="element-4944">
                          {a.grantedAt}
                        </td>
                        <td className="px-3 py-2 text-xs text-slate-500" data-id="element-4945">
                          {a.expiresAt}
                        </td>
                        <td className="px-3 py-2 text-xs" data-id="element-4946">{a.downloads}</td>
                        <td className="px-3 py-2 text-right" data-id="element-4947">
                          {a.accessStatus === 'granted' && iconBtn(<Lock className="w-3.5 h-3.5" data-id="element-4948" />, 'Отозвать', () => handleRevokeAccess(a.id), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                          {a.accessStatus !== 'granted' && iconBtn(<Unlock className="w-3.5 h-3.5" data-id="element-4949" />, 'Открыть', () => handleGrantAccess(a.id), 'text-slate-400 hover:text-emerald-600 hover:bg-emerald-50')}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div> : <div className="text-sm text-slate-500 p-4 bg-slate-50 rounded-lg text-center" data-id="element-4950">
                Нет записей о доступах
              </div>}
          </div>}

        {detailTab === 'sales' && <div className="space-y-4" data-id="element-4951">
            <h4 className="font-bold text-slate-900" data-id="element-4952">
              Заказы по товару ({productOrders.length})
            </h4>
            {productOrders.length === 0 ? <div className="text-sm text-slate-500 p-4 bg-slate-50 rounded-lg text-center" data-id="element-4953">
                Нет заказов
              </div> : <table className="w-full text-left text-sm" data-id="element-4954">
                <thead className="bg-slate-50 text-slate-500 text-xs" data-id="element-4955">
                  <tr data-id="element-4956">
                    <th className="px-3 py-2" data-id="element-4957">Заказ</th>
                    <th className="px-3 py-2" data-id="element-4958">Покупатель</th>
                    <th className="px-3 py-2" data-id="element-4959">Сумма</th>
                    <th className="px-3 py-2" data-id="element-4960">Статус</th>
                    <th className="px-3 py-2" data-id="element-4961">Дата</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-4962">
                  {productOrders.map(o => <tr key={o.id} data-id="element-4963">
                      <td className="px-3 py-2 font-medium" data-id="element-4964">{o.id}</td>
                      <td className="px-3 py-2" data-id="element-4965">{o.buyerName}</td>
                      <td className="px-3 py-2" data-id="element-4966">{o.price}</td>
                      <td className="px-3 py-2" data-id="element-4967">
                        {renderStatusBadge(o.status)}
                      </td>
                      <td className="px-3 py-2 text-slate-500" data-id="element-4968">
                        {o.createdAt}
                      </td>
                    </tr>)}
                </tbody>
              </table>}
          </div>}

        {detailTab === 'finance' && <div className="space-y-4" data-id="element-4969">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-4970">
              <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-100" data-id="element-4971">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4972">
                  💰 Общий доход (Revenue)
                </span>
                <div className="text-2xl font-bold text-emerald-700 mt-1" data-id="element-4973">
                  {totalRev.toLocaleString('ru-RU')} ₽
                </div>
              </div>
              <div className="p-4 bg-indigo-50 rounded-lg border border-indigo-100" data-id="element-4974">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4975">
                  🏢 Доход платформы (Profit)
                </span>
                <div className="text-2xl font-bold text-indigo-700 mt-1" data-id="element-4976">
                  {totalComm.toLocaleString('ru-RU')} ₽
                </div>
                <div className="text-[10px] text-indigo-500 mt-0.5" data-id="element-4977">
                  {totalRev > 0 ? Math.round(totalComm / totalRev * 100) : 0}%
                  от выручки
                </div>
              </div>
              <div className="p-4 bg-sky-50 rounded-lg border border-sky-100" data-id="element-4978">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4979">
                  👤 Выплата продавцу (Payout)
                </span>
                <div className="text-2xl font-bold text-sky-700 mt-1" data-id="element-4980">
                  {(totalRev - totalComm).toLocaleString('ru-RU')} ₽
                </div>
                <div className="text-[10px] text-sky-500 mt-0.5" data-id="element-4981">
                  {totalRev > 0 ? Math.round((totalRev - totalComm) / totalRev * 100) : 0}
                  % от выручки
                </div>
              </div>
              <div className="p-4 bg-rose-50 rounded-lg border border-rose-100" data-id="element-4982">
                <span className="text-xs text-slate-500 font-medium" data-id="element-4983">
                  🔄 Возвраты / Споры
                </span>
                <div className="text-2xl font-bold text-rose-700 mt-1" data-id="element-4984">
                  {refundCount} / {productDisputes.length}
                </div>
                <div className="text-[10px] text-rose-500 mt-0.5" data-id="element-4985">
                  {productOrders.length > 0 ? Math.round(refundCount / productOrders.length * 100) : 0}
                  % возвратов
                </div>
              </div>
            </div>
            {/* Revenue breakdown bar */}
            {totalRev > 0 && <div className="p-4 bg-slate-50 rounded-lg" data-id="element-4986">
                <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-4987">
                  Распределение дохода
                </div>
                <div className="flex rounded-full h-4 overflow-hidden" data-id="element-4988">
                  <div className="bg-indigo-500 transition-all" style={{
              width: `${Math.round(totalComm / totalRev * 100)}%`
            }} title={`Платформа: ${totalComm.toLocaleString('ru-RU')} ₽`} data-id="element-4989" />
                  <div className="bg-sky-400 transition-all" style={{
              width: `${Math.round((totalRev - totalComm) / totalRev * 100)}%`
            }} title={`Продавец: ${(totalRev - totalComm).toLocaleString('ru-RU')} ₽`} data-id="element-4990" />
                </div>
                <div className="flex justify-between mt-2 text-[10px]" data-id="element-4991">
                  <span className="flex items-center gap-1" data-id="element-4992">
                    <span className="w-2 h-2 rounded-full bg-indigo-500" data-id="element-4993" />{' '}
                    Платформа ({Math.round(totalComm / totalRev * 100)}%)
                  </span>
                  <span className="flex items-center gap-1" data-id="element-4994">
                    <span className="w-2 h-2 rounded-full bg-sky-400" data-id="element-4995" />{' '}
                    Продавец (
                    {Math.round((totalRev - totalComm) / totalRev * 100)}%)
                  </span>
                </div>
              </div>}
          </div>}

        {detailTab === 'ai' && <div className="space-y-4" data-id="element-4996">
            {aiData ? <>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-4997">
                  <div className="p-4 bg-indigo-50 rounded-lg border border-indigo-100" data-id="element-4998">
                    <div className="flex items-center gap-2 mb-1" data-id="element-4999">
                      <Cpu className="w-4 h-4 text-indigo-500" data-id="element-5000" />
                      <span className="text-xs text-slate-500 font-medium" data-id="element-5001">
                        Генерации
                      </span>
                    </div>
                    <div className="text-2xl font-bold text-indigo-700" data-id="element-5002">
                      {aiData.generations}
                    </div>
                  </div>
                  <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-100" data-id="element-5003">
                    <div className="flex items-center gap-2 mb-1" data-id="element-5004">
                      <FileText className="w-4 h-4 text-emerald-500" data-id="element-5005" />
                      <span className="text-xs text-slate-500 font-medium" data-id="element-5006">
                        PDF выдано
                      </span>
                    </div>
                    <div className="text-2xl font-bold text-emerald-700" data-id="element-5007">
                      {aiData.pdfsGenerated}
                    </div>
                  </div>
                  <div className="p-4 bg-rose-50 rounded-lg border border-rose-100" data-id="element-5008">
                    <div className="flex items-center gap-2 mb-1" data-id="element-5009">
                      <AlertTriangle className="w-4 h-4 text-rose-500" data-id="element-5010" />
                      <span className="text-xs text-slate-500 font-medium" data-id="element-5011">
                        Ошибки
                      </span>
                    </div>
                    <div className="text-2xl font-bold text-rose-700" data-id="element-5012">
                      {aiData.errors}
                    </div>
                  </div>
                  <div className="p-4 bg-amber-50 rounded-lg border border-amber-100" data-id="element-5013">
                    <div className="flex items-center gap-2 mb-1" data-id="element-5014">
                      <Star className="w-4 h-4 text-amber-500" data-id="element-5015" />
                      <span className="text-xs text-slate-500 font-medium" data-id="element-5016">
                        Качество
                      </span>
                    </div>
                    <div className="text-2xl font-bold text-amber-700" data-id="element-5017">
                      {aiData.quality}%
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-5018">
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-5019">
                    <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-5020">
                      Последняя генерация
                    </span>
                    <div className="text-sm font-medium text-slate-900 mt-1" data-id="element-5021">
                      {aiData.lastGeneration}
                    </div>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-5022">
                    <span className="text-[10px] text-slate-500 uppercase font-semibold" data-id="element-5023">
                      Среднее время
                    </span>
                    <div className="text-sm font-medium text-slate-900 mt-1" data-id="element-5024">
                      {aiData.avgTime}
                    </div>
                  </div>
                </div>
                {aiData.errors > 0 && <div className="p-3 bg-rose-50 rounded-lg border border-rose-200" data-id="element-5025">
                    <div className="text-xs font-bold text-rose-700 mb-1" data-id="element-5026">
                      ⚠ Последние ошибки
                    </div>
                    <div className="text-sm text-rose-600" data-id="element-5027">
                      Обнаружено {aiData.errors} ошибок генерации. Рекомендуется
                      проверить шаблон и входные данные.
                    </div>
                    <Button size="sm" variant="outline" className="mt-2 text-rose-600 border-rose-200" onClick={() => success('Открыт лог ошибок AI')} data-id="element-5028">
                      Смотреть лог ошибок
                    </Button>
                  </div>}
              </> : <div className="text-center py-8" data-id="element-5029">
                <Zap className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-5030" />
                <div className="text-sm text-slate-500" data-id="element-5031">
                  AI-генерации для этого товара не найдены
                </div>
              </div>}
          </div>}

        {detailTab === 'reviews' && <div className="space-y-3" data-id="element-5032">
            <h4 className="font-bold text-slate-900" data-id="element-5033">
              Отзывы ({productReviews.length})
            </h4>
            {productReviews.map(r => <div key={r.id} className="p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-5034">
                <div className="flex justify-between items-start mb-1" data-id="element-5035">
                  <span className="font-medium text-sm text-slate-900" data-id="element-5036">
                    {r.buyerName}
                  </span>
                  <div className="flex items-center gap-1 text-amber-400 text-xs" data-id="element-5037">
                    ★ {r.rating}
                  </div>
                </div>
                <p className="text-sm text-slate-700" data-id="element-5038">{r.text}</p>
                <div className="flex items-center justify-between mt-2" data-id="element-5039">
                  <span className="text-xs text-slate-400" data-id="element-5040">{r.createdAt}</span>
                  {renderStatusBadge(r.status)}
                </div>
              </div>)}
            {productReviews.length === 0 && <div className="text-sm text-slate-500 p-4 bg-slate-50 rounded-lg text-center" data-id="element-5041">
                Нет отзывов
              </div>}
          </div>}

        {detailTab === 'ads' && <div className="space-y-4" data-id="element-5042">
            {adData?.active ? <>
                <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-200 flex items-center gap-2" data-id="element-5043">
                  <Megaphone className="w-5 h-5 text-emerald-600" data-id="element-5044" />
                  <span className="text-sm font-medium text-emerald-700" data-id="element-5045">
                    Реклама активна
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-5046">
                  <div className="p-4 bg-blue-50 rounded-lg border border-blue-100" data-id="element-5047">
                    <span className="text-xs text-slate-500 font-medium" data-id="element-5048">
                      Показы
                    </span>
                    <div className="text-2xl font-bold text-blue-700 mt-1" data-id="element-5049">
                      {adData.impressions.toLocaleString()}
                    </div>
                  </div>
                  <div className="p-4 bg-purple-50 rounded-lg border border-purple-100" data-id="element-5050">
                    <span className="text-xs text-slate-500 font-medium" data-id="element-5051">
                      Клики
                    </span>
                    <div className="text-2xl font-bold text-purple-700 mt-1" data-id="element-5052">
                      {adData.clicks.toLocaleString()}
                    </div>
                    <div className="text-[10px] text-purple-500 mt-0.5" data-id="element-5053">
                      CTR:{' '}
                      {(adData.clicks / adData.impressions * 100).toFixed(1)}%
                    </div>
                  </div>
                </div>
              </> : <div className="text-center py-8" data-id="element-5054">
                <Megaphone className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-5055" />
                <div className="text-sm text-slate-500" data-id="element-5056">
                  Рекламных кампаний для этого товара пока нет
                </div>
                <Button variant="outline" size="sm" className="mt-4" onClick={() => success('Открыт менеджер рекламы')} data-id="element-5057">
                  Создать кампанию
                </Button>
              </div>}
          </div>}

        {detailTab === 'history' && <div className="space-y-2" data-id="element-5058">
            {[{
          date: selectedProduct.createdAt,
          action: 'Товар создан',
          by: selectedProduct.authorName
        }, {
          date: selectedProduct.updatedAt,
          action: 'Последнее обновление',
          by: selectedProduct.authorName
        }, ...(selectedProduct.status === 'active' ? [{
          date: selectedProduct.updatedAt,
          action: 'Одобрен модератором',
          by: 'Администратор'
        }] : [])].map((h, i) => <div key={i} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-5059">
                <Clock className="w-4 h-4 text-slate-400 flex-shrink-0" data-id="element-5060" />
                <div className="flex-1" data-id="element-5061">
                  <span className="text-sm font-medium text-slate-900" data-id="element-5062">
                    {h.action}
                  </span>
                  <span className="text-xs text-slate-500 ml-2" data-id="element-5063">— {h.by}</span>
                </div>
                <span className="text-xs text-slate-400" data-id="element-5064">{h.date}</span>
              </div>)}
          </div>}
      </div>;
  };
  // ========== PRODUCTS TAB (WITH PAGINATION) ==========
  const renderProducts = () => {
    const totalProductPages = Math.ceil(filteredProducts.length / ITEMS_PER_PAGE);
    const paginatedProducts = filteredProducts.slice((productsPage - 1) * ITEMS_PER_PAGE, productsPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5065">
        <div className="flex flex-col sm:flex-row justify-between gap-4" data-id="element-5066">
          <div className="relative flex-1 max-w-lg" data-id="element-5067">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5068" />
            <Input placeholder="Поиск по ID, названию, астрологу..." value={searchInput} onChange={e => handleSearchChange(e.target.value)} className="pl-9" data-id="element-5069" />
          </div>
          <div className="flex gap-2 flex-wrap" data-id="element-5070">
            <Button variant={showFilters ? 'primary' : 'outline'} icon={<Search className="w-4 h-4" data-id="element-5072" />} onClick={() => setShowFilters(!showFilters)} data-id="element-5071">
              Фильтры
            </Button>
            <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-5074" />} onClick={() => success(`Экспорт ${filteredProducts.length} товаров начат`)} data-id="element-5073">
              Экспорт
            </Button>
            <Button variant="outline" icon={<Upload className="w-4 h-4" data-id="element-5076" />} onClick={() => success('Импорт: загрузите CSV/XLSX файл')} data-id="element-5075">
              Импорт
            </Button>
            <Button icon={<Plus className="w-4 h-4" data-id="element-5078" />} onClick={() => success('Открыта форма создания товара')} data-id="element-5077">
              Создать товар
            </Button>
          </div>
        </div>
        {showFilters && <>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-5079">
              <div data-id="element-5080">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5081">
                  Статус
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={statusFilter} onChange={e => {
              setStatusFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5082">
                  {STATUS_OPTIONS.map(o => <option key={o.value} value={o.value} data-id="element-5083">
                      {o.label}
                    </option>)}
                </select>
              </div>
              <div data-id="element-5084">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5085">
                  Тип
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={typeFilter} onChange={e => {
              setTypeFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5086">
                  {TYPE_OPTIONS.map(o => <option key={o.value} value={o.value} data-id="element-5087">
                      {o.label}
                    </option>)}
                </select>
              </div>
              <div data-id="element-5088">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5089">
                  Категория
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={categoryFilter} onChange={e => {
              setCategoryFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5090">
                  <option value="all" data-id="element-5091">Все</option>
                  {CATEGORIES.map(c => <option key={c.id} value={c.name} data-id="element-5092">
                      {c.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-5093">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5094">
                  Астролог
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={astrologerFilter} onChange={e => {
              setAstrologerFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5095">
                  <option value="all" data-id="element-5096">Все</option>
                  {sellers.map(s => <option key={s.id} value={s.id} data-id="element-5097">
                      {s.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-5098">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5099">
                  Рейтинг от
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={ratingFilter} onChange={e => {
              setRatingFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5100">
                  <option value="all" data-id="element-5101">Любой</option>
                  <option value="4" data-id="element-5102">4+</option>
                  <option value="4.5" data-id="element-5103">4.5+</option>
                  <option value="5" data-id="element-5104">5</option>
                </select>
              </div>
              <div className="flex items-end" data-id="element-5105">
                <Button variant="ghost" size="sm" onClick={() => {
              setStatusFilter('all');
              setTypeFilter('all');
              setCategoryFilter('all');
              setAstrologerFilter('all');
              setRatingFilter('all');
              setSalesFilter('all');
              setComplaintsFilter('all');
              setRefundsFilter('all');
              setAiFilter('all');
              setAdFilter('all');
              setKpiFilter(null);
              resetProductsPage();
            }} data-id="element-5106">
                  Сбросить
                </Button>
              </div>
            </div>
            {/* Advanced filters row */}
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-5107">
              <div data-id="element-5108">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5109">
                  Продажи
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={salesFilter} onChange={e => {
              setSalesFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5110">
                  <option value="all" data-id="element-5111">Все</option>
                  <option value="has_sales" data-id="element-5112">Есть продажи</option>
                  <option value="no_sales" data-id="element-5113">Без продаж</option>
                </select>
              </div>
              <div data-id="element-5114">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5115">
                  Жалобы
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={complaintsFilter} onChange={e => {
              setComplaintsFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5116">
                  <option value="all" data-id="element-5117">Все</option>
                  <option value="has_complaints" data-id="element-5118">Есть жалобы</option>
                </select>
              </div>
              <div data-id="element-5119">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5120">
                  Возвраты
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={refundsFilter} onChange={e => {
              setRefundsFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5121">
                  <option value="all" data-id="element-5122">Все</option>
                  <option value="has_refunds" data-id="element-5123">Есть возвраты</option>
                </select>
              </div>
              <div data-id="element-5124">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5125">
                  AI
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={aiFilter} onChange={e => {
              setAiFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5126">
                  <option value="all" data-id="element-5127">Все</option>
                  <option value="has_ai" data-id="element-5128">AI товары</option>
                </select>
              </div>
              <div data-id="element-5129">
                <label className="text-[10px] text-slate-500 uppercase font-semibold mb-1 block" data-id="element-5130">
                  Реклама
                </label>
                <select className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg bg-white" value={adFilter} onChange={e => {
              setAdFilter(e.target.value);
              resetProductsPage();
            }} data-id="element-5131">
                  <option value="all" data-id="element-5132">Все</option>
                  <option value="advertised" data-id="element-5133">Рекламируется</option>
                </select>
              </div>
            </div>
          </>}
        <div className="flex items-center justify-between text-xs text-slate-500" data-id="element-5134">
          <span data-id="element-5135">Найдено: {filteredProducts.length} товаров</span>
          <div className="flex items-center gap-3" data-id="element-5136">
            {filteredProducts.length > 20 && <div className="flex items-center gap-1.5" data-id="element-5137">
                <span data-id="element-5138">Показывать:</span>
                {PAGE_SIZE_OPTIONS.map(size => <button key={size} onClick={() => {
              setPageSize(size);
              setProductsPage(1);
            }} className={`px-1.5 py-0.5 rounded text-xs font-medium transition-colors ${pageSize === size ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-slate-100 text-slate-500'}`} data-id="element-5139">
                    {size}
                  </button>)}
              </div>}
            {filteredProducts.length > ITEMS_PER_PAGE && <span data-id="element-5140">
                Стр. {productsPage} из {totalProductPages} •{' '}
                {Math.min(ITEMS_PER_PAGE, paginatedProducts.length)} из{' '}
                {filteredProducts.length}
              </span>}
          </div>
        </div>
        {/* Mass action bar */}
        {massSelectMode && selectedProductIds.size > 0 && <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-3 flex items-center justify-between" data-id="element-5141">
            <div className="flex items-center gap-3" data-id="element-5142">
              <Badge variant="primary" className="bg-indigo-600 text-white border-none" data-id="element-5143">
                {selectedProductIds.size} выбрано
              </Badge>
              {selectedProductIds.size < filteredProducts.length && <button onClick={() => setSelectedProductIds(new Set(filteredProducts.map(p => p.id)))} className="text-xs text-indigo-600 hover:text-indigo-800 underline underline-offset-2" data-id="element-5144">
                  Выбрать все {filteredProducts.length}
                </button>}
              <span className="text-sm text-indigo-700 font-medium" data-id="element-5145">
                Массовые действия:
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-5146">
              <Button size="sm" variant="outline" className="bg-white text-emerald-600 border-emerald-200 hover:bg-emerald-50" onClick={() => handleMassAction('approve')} data-id="element-5147">
                <CheckCircle2 className="w-3.5 h-3.5 mr-1" data-id="element-5148" /> Одобрить
              </Button>
              <Button size="sm" variant="outline" className="bg-white text-slate-600 hover:bg-slate-50" onClick={() => handleMassAction('hide')} data-id="element-5149">
                <EyeOff className="w-3.5 h-3.5 mr-1" data-id="element-5150" /> Скрыть
              </Button>
              <Button size="sm" variant="outline" className="bg-white text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => handleMassAction('archive')} data-id="element-5151">
                <Archive className="w-3.5 h-3.5 mr-1" data-id="element-5152" /> В архив
              </Button>
              <Button size="sm" variant="outline" className="bg-white text-slate-400 hover:text-slate-600" onClick={() => {
            setSelectedProductIds(new Set());
            setMassSelectMode(false);
          }} data-id="element-5153">
                <X className="w-3.5 h-3.5" data-id="element-5154" />
              </Button>
            </div>
          </div>}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5155">
          <div className="overflow-x-auto" data-id="element-5156">
            <table className="w-full text-left text-sm" data-id="element-5157">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5158">
                <tr data-id="element-5159">
                  <th className="w-8 px-2 py-2.5" data-id="element-5160">
                    {massSelectMode && <input type="checkbox" checked={selectedProductIds.size === paginatedProducts.length && paginatedProducts.length > 0} onChange={() => toggleSelectAll(paginatedProducts)} className="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" onClick={e => e.stopPropagation()} data-id="element-5161" />}
                  </th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5162">Товар</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5163">Автор</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5164">Тип</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5165">Цена</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5166">Продажи</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5167">Рейтинг</th>
                  <th className="px-3 py-2.5 font-medium" data-id="element-5168">Статус</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5169">
                {paginatedProducts.map(p => {
                const pOrders = orders.filter(o => o.productId === p.id);
                const commission = pOrders.reduce((s, o) => s + parseInt(o.commissionAmount.replace(/[^\d]/g, '') || '0'), 0);
                const totalRev = pOrders.reduce((s, o) => s + o.priceNum, 0);
                const sellerNet = totalRev - commission;
                const refundCount = pOrders.filter(o => o.status === 'refunded').length;
                const disputeCount = disputes.filter(d => d.productId === p.id && (d.status === 'open' || d.status === 'in_review')).length;
                const problems = getProductProblems(p);
                const money = getMoneyStatus(p);
                const accessCount = getAccessCount(p.id);
                const adActive = AD_STATUS[p.id]?.active || false;
                const isExpanded = expandedProductRow === p.id;
                const itemsCount = p.items?.length || 0;
                const hasConsultation = p.items?.some(i => i.type === 'consultation');
                return <Fragment key={p.id} data-id="element-5170">
                      {/* MAIN ROW — click to expand */}
                      <tr className={`transition-colors cursor-pointer ${problems.length > 0 && !isExpanded ? 'bg-rose-50/30' : ''} ${isExpanded ? 'bg-indigo-50 border-l-[3px] border-l-indigo-500' : 'hover:bg-slate-50 border-l-[3px] border-l-transparent'}`} onClick={() => toggleProductRow(p.id)} data-id="element-5171">
                        <td className="px-2 py-2.5 text-center" data-id="element-5172">
                          {massSelectMode ? <input type="checkbox" checked={selectedProductIds.has(p.id)} onChange={() => toggleProductSelect(p.id)} onClick={e => e.stopPropagation()} className="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-5173" /> : <ChevronDown className={`w-3.5 h-3.5 text-slate-400 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-5174" />}
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5175">
                          <div className="flex items-center gap-2.5" data-id="element-5176">
                            <div className={`w-8 h-8 rounded-lg ${p.coverColor} flex items-center justify-center flex-shrink-0 relative`} data-id="element-5177">
                              <Package className="w-3.5 h-3.5 text-slate-700 opacity-50" data-id="element-5178" />
                              {problems.length > 0 && <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-rose-500 rounded-full flex items-center justify-center text-white text-[7px] font-bold" title={problems.join(', ')} data-id="element-5179">
                                  !
                                </span>}
                            </div>
                            <div className="min-w-0" data-id="element-5180">
                              <div className="font-medium text-slate-900 line-clamp-1 text-xs" title={p.title} data-id="element-5181">
                                {p.title}
                              </div>
                              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-5182">
                                <span className="text-[10px] text-slate-400" data-id="element-5183">
                                  {p.id}
                                </span>
                                {itemsCount > 0 && <span className="text-[9px] px-1 py-0 rounded bg-slate-100 text-slate-500" data-id="element-5184">
                                    {itemsCount} эл.
                                  </span>}
                                {hasConsultation && <span className="text-[9px] px-1 py-0 rounded bg-amber-50 text-amber-600" data-id="element-5185">
                                    консульт.
                                  </span>}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5186">
                          <div className="flex items-center gap-1.5" data-id="element-5187">
                            <div className="w-5 h-5 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-[8px] font-bold" data-id="element-5188">
                              {p.authorAvatar}
                            </div>
                            <span className="text-xs text-slate-700" data-id="element-5189">
                              {p.authorName}
                            </span>
                          </div>
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5190">
                          <Badge variant="neutral" size="sm" className="capitalize text-[10px]" data-id="element-5191">
                            {p.type}
                          </Badge>
                        </td>
                        <td className="px-3 py-2.5 font-medium text-slate-900 text-xs" data-id="element-5192">
                          {p.price}
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5193">
                          <div className="text-xs text-slate-900" data-id="element-5194">
                            {p.salesCount} шт.
                          </div>
                          <div className="text-[10px] text-emerald-600 font-medium" data-id="element-5195">
                            {p.revenue}
                          </div>
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5196">
                          {p.rating > 0 ? <span className={`text-xs flex items-center gap-0.5 font-medium ${p.rating < 3.5 ? 'text-rose-500' : 'text-amber-500'}`} data-id="element-5197">
                              ★ {p.rating}
                              <span className="text-slate-400 font-normal" data-id="element-5198">
                                ({p.reviewsCount})
                              </span>
                            </span> : <span className="text-xs text-slate-400" data-id="element-5199">—</span>}
                        </td>
                        <td className="px-3 py-2.5" data-id="element-5200">
                          {renderStatusBadge(p.status)}
                        </td>
                      </tr>

                      {/* EXPANDED PANEL */}
                      {isExpanded && <tr data-id="element-5201">
                          <td colSpan={8} className="p-0" data-id="element-5202">
                            <div className="mx-2 mb-3 rounded-xl border-2 border-indigo-200 bg-white overflow-hidden shadow-lg shadow-indigo-100/50" data-id="element-5203">
                              {/* Metrics strip */}
                              <div className="bg-gradient-to-r from-indigo-50 to-slate-50 px-5 py-3 flex flex-wrap items-center gap-3 border-b border-indigo-100" data-id="element-5204">
                                {[{
                            icon: <DollarSign className="w-3.5 h-3.5" data-id="element-5205" />,
                            label: 'Комиссия',
                            value: commission > 0 ? `${commission.toLocaleString('ru-RU')} ₽` : '—',
                            color: 'text-indigo-600',
                            iconBg: 'bg-indigo-100 text-indigo-600'
                          }, {
                            icon: <Key className="w-3.5 h-3.5" data-id="element-5206" />,
                            label: 'Доступы',
                            value: accessCount || '—',
                            color: accessCount > 0 ? 'text-cyan-600' : 'text-slate-400',
                            iconBg: 'bg-cyan-100 text-cyan-600'
                          }, {
                            icon: <span className="text-xs" data-id="element-5207">
                                        {money.icon}
                                      </span>,
                            label: 'Доход',
                            value: money.label,
                            color: money.color,
                            iconBg: 'bg-emerald-100 text-emerald-600'
                          }, {
                            icon: <TrendingUp className="w-3.5 h-3.5" data-id="element-5208" />,
                            label: 'Продавцу',
                            value: sellerNet > 0 ? `${sellerNet.toLocaleString('ru-RU')} ₽` : '—',
                            color: 'text-emerald-600',
                            iconBg: 'bg-emerald-100 text-emerald-600'
                          }, {
                            icon: <Megaphone className="w-3.5 h-3.5" data-id="element-5209" />,
                            label: 'Реклама',
                            value: adActive ? 'Вкл' : '—',
                            color: adActive ? 'text-violet-600' : 'text-slate-400',
                            iconBg: 'bg-violet-100 text-violet-600'
                          }].map((m, i) => <div key={i} className="flex items-center gap-2 bg-white/80 rounded-lg px-2.5 py-1.5 border border-slate-100" data-id="element-5210">
                                    <div className={`w-5 h-5 rounded-md flex items-center justify-center ${m.iconBg}`} data-id="element-5211">
                                      {m.icon}
                                    </div>
                                    <div className="text-[11px]" data-id="element-5212">
                                      <span className="text-slate-400" data-id="element-5213">
                                        {m.label}:{' '}
                                      </span>
                                      <b className={m.color} data-id="element-5214">{m.value}</b>
                                    </div>
                                  </div>)}
                                {refundCount > 0 && <div className="flex items-center gap-2 bg-rose-50 rounded-lg px-2.5 py-1.5 border border-rose-200" data-id="element-5215">
                                    <RefreshCw className="w-3.5 h-3.5 text-rose-500" data-id="element-5216" />
                                    <span className="text-[11px] text-rose-600 font-medium" data-id="element-5217">
                                      Возвраты: {refundCount}
                                    </span>
                                  </div>}
                                {disputeCount > 0 && <div className="flex items-center gap-2 bg-orange-50 rounded-lg px-2.5 py-1.5 border border-orange-200" data-id="element-5218">
                                    <AlertTriangle className="w-3.5 h-3.5 text-orange-500" data-id="element-5219" />
                                    <span className="text-[11px] text-orange-600 font-medium" data-id="element-5220">
                                      Споры: {disputeCount}
                                    </span>
                                  </div>}
                                <span className="text-[10px] text-slate-400 ml-auto flex items-center gap-1" data-id="element-5221">
                                  <Clock className="w-3 h-3" data-id="element-5222" /> {p.createdAt}
                                </span>
                              </div>

                              {/* Product items */}
                              {p.items && p.items.length > 0 && <div className="bg-slate-50/80 px-5 py-2.5 border-b border-slate-200 flex flex-wrap items-center gap-1.5" data-id="element-5223">
                                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wide mr-1.5" data-id="element-5224">
                                    Состав ({p.items.length}):
                                  </span>
                                  {[...p.items].sort((a, b) => a.sortOrder - b.sortOrder).map(item => {
                            const typeIcons: Record<string, string> = {
                              pdf: '📄',
                              video: '🎬',
                              consultation: '👤',
                              bonus: '🎁',
                              checklist: '✅',
                              module: '📦',
                              audio: '🎧',
                              file: '📎'
                            };
                            return <span key={item.id} className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-md border ${item.type === 'consultation' ? 'bg-amber-50 border-amber-200 text-amber-700' : 'bg-white border-slate-200 text-slate-600'}`} data-id="element-5225">
                                          {typeIcons[item.type] || '📎'}{' '}
                                          <span className="truncate max-w-[140px]" data-id="element-5226">
                                            {item.title}
                                          </span>
                                          {item.fileSize && <span className="text-slate-400" data-id="element-5227">
                                              ({item.fileSize})
                                            </span>}
                                        </span>;
                          })}
                                </div>}

                              {/* Tabs + actions */}
                              <div className="flex border-b border-slate-200 overflow-x-auto scrollbar-hide bg-white" data-id="element-5228">
                                {[{
                            id: 'info',
                            label: 'Основное',
                            icon: FileText
                          }, {
                            id: 'content',
                            label: 'Контент',
                            icon: Video
                          }, {
                            id: 'access',
                            label: `Доступы (${getAccessCount(p.id)})`,
                            icon: Key
                          }, {
                            id: 'sales',
                            label: `Продажи (${orders.filter(o => o.productId === p.id).length})`,
                            icon: ShoppingBag
                          }, {
                            id: 'finance',
                            label: 'Финансы',
                            icon: DollarSign
                          }, {
                            id: 'ai',
                            label: 'AI / ИИ',
                            icon: Zap
                          }, {
                            id: 'reviews',
                            label: `Отзывы (${reviews.filter(r => r.productId === p.id).length})`,
                            icon: Star
                          }, {
                            id: 'ads',
                            label: (AD_STATUS[p.id]?.active ? '📢 ' : '') + 'Реклама',
                            icon: Megaphone
                          }, {
                            id: 'history',
                            label: 'История',
                            icon: History
                          }].map(t => <button key={t.id} onClick={e => {
                            e.stopPropagation();
                            setDetailTab(t.id as any);
                            setSelectedProductId(p.id);
                          }} className={`flex items-center gap-1.5 px-3.5 py-2.5 text-[11px] font-medium whitespace-nowrap border-b-2 transition-colors ${detailTab === t.id && selectedProductId === p.id ? 'border-indigo-600 text-indigo-600 bg-indigo-50/50' : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'}`} data-id="element-5229">
                                    <t.icon className="w-3.5 h-3.5" data-id="element-5230" />
                                    {t.label}
                                  </button>)}
                                <div className="ml-auto flex items-center gap-1 px-3 flex-shrink-0 border-l border-slate-100" data-id="element-5231">
                                  <button onClick={e => {
                              e.stopPropagation();
                              success(`Редактирование ${p.id}`);
                            }} className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-md transition-colors" title="Редактировать" data-id="element-5232">
                                    <Edit2 className="w-3.5 h-3.5" data-id="element-5233" />
                                  </button>
                                  {p.status === 'moderation' && <>
                                      <button onClick={e => {
                                e.stopPropagation();
                                changeStatus(p.id, 'active', `${p.id} одобрен`);
                              }} className="p-1.5 text-emerald-500 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors" title="Одобрить" data-id="element-5234">
                                        <CheckCircle2 className="w-3.5 h-3.5" data-id="element-5235" />
                                      </button>
                                      <button onClick={e => {
                                e.stopPropagation();
                                changeStatus(p.id, 'rejected', `${p.id} отклонён`);
                              }} className="p-1.5 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-md transition-colors" title="Отклонить" data-id="element-5236">
                                        <XCircle className="w-3.5 h-3.5" data-id="element-5237" />
                                      </button>
                                    </>}
                                  {p.status === 'active' && <button onClick={e => {
                              e.stopPropagation();
                              changeStatus(p.id, 'hidden', `${p.id} скрыт`);
                            }} className="p-1.5 text-slate-400 hover:text-rose-600 hover:bg-rose-50 rounded-md transition-colors" title="Скрыть" data-id="element-5238">
                                      <EyeOff className="w-3.5 h-3.5" data-id="element-5239" />
                                    </button>}
                                  {p.status === 'hidden' && <button onClick={e => {
                              e.stopPropagation();
                              changeStatus(p.id, 'active', `${p.id} активирован`);
                            }} className="p-1.5 text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors" title="Активировать" data-id="element-5240">
                                      <Eye className="w-3.5 h-3.5" data-id="element-5241" />
                                    </button>}
                                  <button onClick={e => {
                              e.stopPropagation();
                              changeStatus(p.id, 'archived', `${p.id} в архив`);
                            }} className="p-1.5 text-slate-300 hover:text-slate-600 hover:bg-slate-100 rounded-md transition-colors" title="В архив" data-id="element-5242">
                                    <Archive className="w-3.5 h-3.5" data-id="element-5243" />
                                  </button>
                                </div>
                              </div>

                              {/* Tab content */}
                              <div className="bg-slate-50/30" data-id="element-5244">
                                {selectedProductId === p.id && renderProductDetail()}
                              </div>
                            </div>
                          </td>
                        </tr>}
                    </Fragment>;
              })}
              </tbody>
            </table>
          </div>
        </div>
        {totalProductPages > 1 && <Pagination currentPage={productsPage} totalPages={totalProductPages} onPageChange={setProductsPage} data-id="element-5245" />}
      </div>;
  };
  // ========== SELLERS (WITH PAGINATION) ==========
  const renderSellers = () => {
    const totalSellerPages = Math.ceil(filteredSellers.length / ITEMS_PER_PAGE);
    const paginatedSellers = filteredSellers.slice((sellersPage - 1) * ITEMS_PER_PAGE, sellersPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5246">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4" data-id="element-5247">
          <div className="relative flex-1 max-w-md" data-id="element-5248">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5249" />
            <Input placeholder="Поиск продавцов..." value={sellersSearch} onChange={e => {
            setSellersSearch(e.target.value);
            setSellersPage(1);
          }} className="pl-9" data-id="element-5250" />
          </div>
          <div className="flex items-center gap-3" data-id="element-5251">
            <span className="text-xs text-slate-500" data-id="element-5252">
              Найдено: {filteredSellers.length}
            </span>
            <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-5254" />} onClick={() => success(`Экспорт ${filteredSellers.length} продавцов`)} data-id="element-5253">
              Экспорт
            </Button>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5255">
          <div className="overflow-x-auto" data-id="element-5256">
            <table className="w-full text-left text-sm" data-id="element-5257">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5258">
                <tr data-id="element-5259">
                  <th className="px-4 py-3 font-medium" data-id="element-5260">Продавец</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5261">Товары</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5262">Продажи</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5263">Доход</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5264">Баланс</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5265">Выплачено</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5266">Рейтинг</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5267">Жалобы</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5268">Статус</th>
                  <th className="px-4 py-3 font-medium text-right" data-id="element-5269">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5270">
                {paginatedSellers.map(s => <tr key={s.id} className="hover:bg-slate-50 transition-colors" data-id="element-5271">
                    <td className="px-4 py-3" data-id="element-5272">
                      <div className="font-medium text-slate-900" data-id="element-5273">{s.name}</div>
                      <div className="text-xs text-slate-500" data-id="element-5274">{s.email}</div>
                    </td>
                    <td className="px-4 py-3" data-id="element-5275">{s.productsCount}</td>
                    <td className="px-4 py-3" data-id="element-5276">{s.totalSales}</td>
                    <td className="px-4 py-3 font-medium text-emerald-600" data-id="element-5277">
                      {s.totalRevenue}
                    </td>
                    <td className="px-4 py-3 font-medium text-indigo-600" data-id="element-5278">
                      {s.balance}
                    </td>
                    <td className="px-4 py-3 text-slate-500" data-id="element-5279">{s.paidOut}</td>
                    <td className="px-4 py-3" data-id="element-5280">
                      <span className="text-amber-500 text-xs font-medium" data-id="element-5281">
                        ★ {s.rating || '—'}
                      </span>
                    </td>
                    <td className="px-4 py-3" data-id="element-5282">
                      {s.complaintsCount > 0 ? <span className="text-rose-600 font-medium flex items-center gap-1" data-id="element-5283">
                          <AlertTriangle className="w-3 h-3" data-id="element-5284" />
                          {s.complaintsCount}
                        </span> : <span className="text-slate-400" data-id="element-5285">0</span>}
                    </td>
                    <td className="px-4 py-3" data-id="element-5286">{renderStatusBadge(s.status)}</td>
                    <td className="px-4 py-3 text-right" data-id="element-5287">
                      <div className="flex items-center justify-end gap-1" data-id="element-5288">
                        {iconBtn(<Eye className="w-4 h-4" data-id="element-5289" />, 'Профиль', () => success(`Профиль ${s.name}`))}
                        {iconBtn(<DollarSign className="w-4 h-4" data-id="element-5290" />, 'Финансы', () => success(`Финансы продавца ${s.name}`))}
                        {iconBtn(<ShoppingBag className="w-4 h-4" data-id="element-5291" />, 'Товары', () => success(`Товары продавца ${s.name}`))}
                        {s.status === 'blocked' ? iconBtn(<UserCheck className="w-4 h-4" data-id="element-5292" />, 'Разблокировать', () => handleUnblockSeller(s.id), 'text-slate-400 hover:text-emerald-600 hover:bg-emerald-50') : iconBtn(<Ban className="w-4 h-4" data-id="element-5293" />, 'Заблокировать', () => handleBlockSeller(s.id), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {totalSellerPages > 1 && <Pagination currentPage={sellersPage} totalPages={totalSellerPages} onPageChange={setSellersPage} data-id="element-5294" />}
      </div>;
  };
  // ========== ORDERS (WITH PAGINATION) ==========
  const renderOrders = () => {
    const totalOrderPages = Math.ceil(filteredOrders.length / ITEMS_PER_PAGE);
    const paginatedOrders = filteredOrders.slice((ordersPage - 1) * ITEMS_PER_PAGE, ordersPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5295">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4" data-id="element-5296">
          <div className="relative flex-1 max-w-md" data-id="element-5297">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5298" />
            <Input placeholder="Поиск заказов..." value={ordersSearch} onChange={e => {
            setOrdersSearch(e.target.value);
            setOrdersPage(1);
          }} className="pl-9" data-id="element-5299" />
          </div>
          <div className="flex gap-2" data-id="element-5300">
            <span className="text-xs text-slate-500 self-center" data-id="element-5301">
              Найдено: {filteredOrders.length}
            </span>
            <Button variant="outline" icon={<Search className="w-4 h-4" data-id="element-5303" />} onClick={() => success('Фильтры заказов (в разработке)')} data-id="element-5302">
              Фильтры
            </Button>
            <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-5305" />} onClick={() => success(`Экспорт ${filteredOrders.length} заказов`)} data-id="element-5304">
              Экспорт
            </Button>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5306">
          <div className="overflow-x-auto" data-id="element-5307">
            <table className="w-full text-left text-sm" data-id="element-5308">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5309">
                <tr data-id="element-5310">
                  <th className="px-3 py-3 font-medium" data-id="element-5311">Заказ</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5312">Покупатель</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5313">Товар</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5314">Продавец</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5315">Сумма</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5316">Комиссия</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5317">Продавцу</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5318">Оплата</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5319">Статус</th>
                  <th className="px-3 py-3 font-medium text-right" data-id="element-5320">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5321">
                {paginatedOrders.map(o => <tr key={o.id} className="hover:bg-slate-50 transition-colors" data-id="element-5322">
                    <td className="px-3 py-3" data-id="element-5323">
                      <div className="font-medium text-slate-900 text-xs" data-id="element-5324">
                        {o.id}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-5325">
                        {o.createdAt}
                      </div>
                    </td>
                    <td className="px-3 py-3" data-id="element-5326">
                      <div className="text-xs text-slate-900" data-id="element-5327">
                        {o.buyerName}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-5328">
                        {o.buyerEmail}
                      </div>
                    </td>
                    <td className="px-3 py-3" data-id="element-5329">
                      <div className="text-xs text-slate-900 line-clamp-1" title={o.productTitle} data-id="element-5330">
                        {o.productTitle}
                      </div>
                    </td>
                    <td className="px-3 py-3 text-xs text-slate-600" data-id="element-5331">
                      {o.sellerName}
                    </td>
                    <td className="px-3 py-3 font-medium text-xs text-slate-900" data-id="element-5332">
                      {o.price}
                    </td>
                    <td className="px-3 py-3 text-xs text-indigo-600" data-id="element-5333">
                      {o.commissionAmount} ({o.platformCommission}%)
                    </td>
                    <td className="px-3 py-3 text-xs text-emerald-600 font-medium" data-id="element-5334">
                      {o.sellerPayout}
                    </td>
                    <td className="px-3 py-3 text-[10px] text-slate-500" data-id="element-5335">
                      {o.paymentMethod}
                    </td>
                    <td className="px-3 py-3" data-id="element-5336">{renderStatusBadge(o.status)}</td>
                    <td className="px-3 py-3 text-right" data-id="element-5337">
                      <div className="flex items-center justify-end gap-0.5" data-id="element-5338">
                        {iconBtn(<Eye className="w-3.5 h-3.5" data-id="element-5339" />, 'Детали', () => success(`Детали заказа ${o.id}: ${o.productTitle}, ${o.price}`))}
                        {(o.status === 'paid' || o.status === 'access_granted') && iconBtn(<RefreshCw className="w-3.5 h-3.5" data-id="element-5340" />, 'Возврат', () => handleRefundOrder(o.id), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {totalOrderPages > 1 && <Pagination currentPage={ordersPage} totalPages={totalOrderPages} onPageChange={setOrdersPage} data-id="element-5341" />}
      </div>;
  };
  // ========== PAYOUTS ==========
  const renderPayouts = () => {
    const pendingTotal = payouts.filter(p => p.status === 'pending').reduce((s, p) => s + parseInt(p.amount.replace(/[^\d]/g, '') || '0'), 0);
    const paidTotal = payouts.filter(p => p.status === 'paid_out').reduce((s, p) => s + parseInt(p.amount.replace(/[^\d]/g, '') || '0'), 0);
    return <div className="space-y-4" data-id="element-5342">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" data-id="element-5343">
          <Card padding="sm" className="bg-amber-50/50 border-amber-100" data-id="element-5344">
            <div className="text-sm text-slate-500" data-id="element-5345">Ожидает выплаты</div>
            <div className="text-xl font-bold text-amber-700" data-id="element-5346">
              {pendingTotal.toLocaleString('ru-RU')} ₽
            </div>
          </Card>
          <Card padding="sm" className="bg-emerald-50/50 border-emerald-100" data-id="element-5347">
            <div className="text-sm text-slate-500" data-id="element-5348">Выплачено (всего)</div>
            <div className="text-xl font-bold text-emerald-700" data-id="element-5349">
              {paidTotal.toLocaleString('ru-RU')} ₽
            </div>
          </Card>
          <Card padding="sm" className="bg-rose-50/50 border-rose-100" data-id="element-5350">
            <div className="text-sm text-slate-500" data-id="element-5351">Ошибки</div>
            <div className="text-xl font-bold text-rose-700" data-id="element-5352">
              {payouts.filter(p => p.status === 'failed').length}
            </div>
          </Card>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5353">
          <div className="overflow-x-auto" data-id="element-5354">
            <table className="w-full text-left text-sm" data-id="element-5355">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5356">
                <tr data-id="element-5357">
                  <th className="px-4 py-3 font-medium" data-id="element-5358">ID</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5359">Продавец</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5360">Сумма</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5361">Дата</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5362">Статус</th>
                  <th className="px-4 py-3 font-medium text-right" data-id="element-5363">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5364">
                {payouts.map(p => <tr key={p.id} className="hover:bg-slate-50" data-id="element-5365">
                    <td className="px-4 py-3 font-medium text-slate-900" data-id="element-5366">
                      {p.id}
                    </td>
                    <td className="px-4 py-3" data-id="element-5367">
                      <div className="text-slate-900" data-id="element-5368">{p.sellerName}</div>
                      <div className="text-xs text-slate-500" data-id="element-5369">{p.sellerId}</div>
                    </td>
                    <td className="px-4 py-3 font-bold text-slate-900" data-id="element-5370">
                      {p.amount}
                    </td>
                    <td className="px-4 py-3 text-slate-500" data-id="element-5371">{p.createdAt}</td>
                    <td className="px-4 py-3" data-id="element-5372">{renderStatusBadge(p.status)}</td>
                    <td className="px-4 py-3 text-right" data-id="element-5373">
                      {p.status === 'pending' && <Button size="sm" onClick={() => handleApprovePayout(p.id)} data-id="element-5374">
                          Выплатить
                        </Button>}
                      {p.status === 'failed' && <Button size="sm" variant="outline" onClick={() => handleRetryPayout(p.id)} data-id="element-5375">
                          Повторить
                        </Button>}
                      {p.status === 'paid_out' && <span className="text-xs text-slate-400 font-mono" data-id="element-5376">
                          {p.transactionId}
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>;
  };
  // ========== CATEGORIES ==========
  const renderCategories = () => <div className="space-y-4" data-id="element-5377">
      <div className="flex justify-between items-center mb-4" data-id="element-5378">
        <h3 className="text-lg font-bold text-slate-900" data-id="element-5379">Категории товаров</h3>
        <Button icon={<Plus className="w-4 h-4" data-id="element-5381" />} onClick={() => success('Создание категории')} data-id="element-5380">
          Добавить
        </Button>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5382">
        <table className="w-full text-left text-sm" data-id="element-5383">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5384">
            <tr data-id="element-5385">
              <th className="px-4 py-3 font-medium" data-id="element-5386">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-5387">Slug</th>
              <th className="px-4 py-3 font-medium" data-id="element-5388">Товаров</th>
              <th className="px-4 py-3 font-medium" data-id="element-5389">Описание</th>
              <th className="px-4 py-3 font-medium text-right" data-id="element-5390">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5391">
            {categories.map(c => <tr key={c.id} className="hover:bg-slate-50" data-id="element-5392">
                <td className="px-4 py-3 font-medium text-slate-900 flex items-center gap-2" data-id="element-5393">
                  <Folder className="w-4 h-4 text-indigo-500" data-id="element-5394" />
                  {c.name}
                </td>
                <td className="px-4 py-3 text-slate-500 font-mono text-xs" data-id="element-5395">
                  {c.slug}
                </td>
                <td className="px-4 py-3" data-id="element-5396">{c.productsCount}</td>
                <td className="px-4 py-3 text-slate-600 text-xs" data-id="element-5397">
                  {c.description}
                </td>
                <td className="px-4 py-3 text-right" data-id="element-5398">
                  <div className="flex items-center justify-end gap-1" data-id="element-5399">
                    {iconBtn(<Edit2 className="w-4 h-4" data-id="element-5400" />, 'Редактировать', () => success(`Редактирование ${c.name}`))}
                    {iconBtn(<Trash2 className="w-4 h-4" data-id="element-5401" />, 'Удалить', () => handleDeleteCategory(c.id, c.name), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  // ========== REVIEWS (WITH PAGINATION) ==========
  const renderReviews = () => {
    const totalReviewPages = Math.ceil(filteredReviews.length / ITEMS_PER_PAGE);
    const paginatedReviews = filteredReviews.slice((reviewsPage - 1) * ITEMS_PER_PAGE, reviewsPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5402">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4" data-id="element-5403">
          <div className="relative flex-1 max-w-md" data-id="element-5404">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5405" />
            <Input placeholder="Поиск отзывов..." value={reviewsSearch} onChange={e => {
            setReviewsSearch(e.target.value);
            setReviewsPage(1);
          }} className="pl-9" data-id="element-5406" />
          </div>
          <span className="text-xs text-slate-500 self-end" data-id="element-5407">
            Найдено: {filteredReviews.length}
          </span>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5408">
          <table className="w-full text-left text-sm" data-id="element-5409">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5410">
              <tr data-id="element-5411">
                <th className="px-4 py-3 font-medium" data-id="element-5412">Автор</th>
                <th className="px-4 py-3 font-medium" data-id="element-5413">Товар</th>
                <th className="px-4 py-3 font-medium" data-id="element-5414">Рейтинг</th>
                <th className="px-4 py-3 font-medium" data-id="element-5415">Текст</th>
                <th className="px-4 py-3 font-medium" data-id="element-5416">Дата</th>
                <th className="px-4 py-3 font-medium" data-id="element-5417">Статус</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-5418">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-5419">
              {paginatedReviews.map(r => <tr key={r.id} className="hover:bg-slate-50" data-id="element-5420">
                  <td className="px-4 py-3 font-medium text-slate-900" data-id="element-5421">
                    {r.buyerName}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-700 line-clamp-1" data-id="element-5422">
                    {r.productTitle}
                  </td>
                  <td className="px-4 py-3" data-id="element-5423">
                    <span className="text-amber-500 font-medium" data-id="element-5424">
                      {'★'.repeat(r.rating)}
                      {'☆'.repeat(5 - r.rating)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-600 max-w-xs truncate" title={r.text} data-id="element-5425">
                    {r.text}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-500" data-id="element-5426">
                    {r.createdAt}
                  </td>
                  <td className="px-4 py-3" data-id="element-5427">{renderStatusBadge(r.status)}</td>
                  <td className="px-4 py-3 text-right" data-id="element-5428">
                    <div className="flex items-center justify-end gap-1" data-id="element-5429">
                      {r.status !== 'published' && iconBtn(<CheckCircle2 className="w-4 h-4" data-id="element-5430" />, 'Опубликовать', () => handleReviewAction(r.id, 'published'), 'text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50')}
                      {r.status !== 'hidden' && iconBtn(<EyeOff className="w-4 h-4" data-id="element-5431" />, 'Скрыть', () => handleReviewAction(r.id, 'hidden'), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {totalReviewPages > 1 && <Pagination currentPage={reviewsPage} totalPages={totalReviewPages} onPageChange={setReviewsPage} data-id="element-5432" />}
      </div>;
  };
  // ========== MODERATION ==========
  const renderModeration = () => {
    const modProducts = products.filter(p => p.status === 'moderation');
    return <div className="space-y-4" data-id="element-5433">
        <div className="flex justify-between items-center mb-4" data-id="element-5434">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-5435">
            Очередь модерации
          </h3>
          <Badge variant="warning" data-id="element-5436">{modProducts.length} ожидают</Badge>
        </div>
        {modProducts.length === 0 ? <Card padding="xl" className="text-center" data-id="element-5437">
            <ShieldAlert className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-5438" />
            <div className="text-slate-500" data-id="element-5439">Очередь модерации пуста</div>
          </Card> : <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-5440">
            {modProducts.map(p => <Card key={p.id} padding="none" className="overflow-hidden" data-id="element-5441">
                <div className={`h-16 ${p.coverColor} flex items-center justify-center`} data-id="element-5442">
                  <Package className="w-8 h-8 text-slate-700 opacity-20" data-id="element-5443" />
                </div>
                <div className="p-4 space-y-3" data-id="element-5444">
                  <div data-id="element-5445">
                    <div className="font-bold text-slate-900" data-id="element-5446">{p.title}</div>
                    <div className="text-xs text-slate-500" data-id="element-5447">
                      {p.id} • {p.type} • {p.category}
                    </div>
                  </div>
                  <div className="text-sm text-slate-600 line-clamp-2" data-id="element-5448">
                    {p.description}
                  </div>
                  <div className="flex items-center gap-3 text-xs text-slate-500" data-id="element-5449">
                    <span data-id="element-5450">
                      Автор:{' '}
                      <strong className="text-slate-700" data-id="element-5451">{p.authorName}</strong>
                    </span>
                    <span data-id="element-5452">
                      Цена:{' '}
                      <strong className="text-indigo-600" data-id="element-5453">{p.price}</strong>
                    </span>
                    <span data-id="element-5454">Материалов: {p.materials.length}</span>
                  </div>
                  {p.materials.length > 0 && <div className="space-y-1" data-id="element-5455">
                      {p.materials.map((m, i) => <div key={i} className="flex items-center gap-2 text-xs text-slate-600 bg-slate-50 px-2 py-1 rounded" data-id="element-5456">
                          {m.type === 'video' ? <Video className="w-3 h-3" data-id="element-5457" /> : m.type === 'pdf' ? <FileText className="w-3 h-3" data-id="element-5458" /> : <LinkIcon className="w-3 h-3" data-id="element-5459" />}
                          {m.name}{' '}
                          {m.size && <span className="text-slate-400" data-id="element-5460">({m.size})</span>}
                        </div>)}
                    </div>}
                  <div className="flex gap-2 pt-2 border-t border-slate-100" data-id="element-5461">
                    <Button size="sm" variant="outline" className="flex-1" onClick={() => {
                setSelectedProductId(p.id);
                setDetailTab('info');
                setActiveTab('products');
              }} data-id="element-5462">
                      👁 Смотреть
                    </Button>
                    <Button size="sm" variant="primary" className="flex-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => changeStatus(p.id, 'active', `${p.id} одобрен`)} data-id="element-5463">
                      ✅ Одобрить
                    </Button>
                    <Button size="sm" variant="outline" className="flex-1 text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => changeStatus(p.id, 'rejected', `${p.id} отклонён`)} data-id="element-5464">
                      ❌ Отклонить
                    </Button>
                  </div>
                </div>
              </Card>)}
          </div>}
      </div>;
  };
  // ========== DISPUTES (WITH PAGINATION) ==========
  const renderDisputes = () => {
    const totalDisputePages = Math.ceil(filteredDisputes.length / ITEMS_PER_PAGE);
    const paginatedDisputes = filteredDisputes.slice((disputesPage - 1) * ITEMS_PER_PAGE, disputesPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5465">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4" data-id="element-5466">
          <div className="relative flex-1 max-w-md" data-id="element-5467">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5468" />
            <Input placeholder="Поиск споров..." value={disputesSearch} onChange={e => {
            setDisputesSearch(e.target.value);
            setDisputesPage(1);
          }} className="pl-9" data-id="element-5469" />
          </div>
          <span className="text-xs text-slate-500 self-end" data-id="element-5470">
            Найдено: {filteredDisputes.length}
          </span>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5471">
          <div className="overflow-x-auto" data-id="element-5472">
            <table className="w-full text-left text-sm" data-id="element-5473">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5474">
                <tr data-id="element-5475">
                  <th className="px-3 py-3 font-medium" data-id="element-5476">Спор</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5477">Покупатель</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5478">Продавец / Товар</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5479">Причина</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5480">Сумма</th>
                  <th className="px-3 py-3 font-medium" data-id="element-5481">Статус</th>
                  <th className="px-3 py-3 font-medium text-right" data-id="element-5482">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5483">
                {paginatedDisputes.map(d => <tr key={d.id} className="hover:bg-slate-50" data-id="element-5484">
                    <td className="px-3 py-3" data-id="element-5485">
                      <div className="font-medium text-slate-900 text-xs" data-id="element-5486">
                        {d.id}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-5487">
                        {d.orderId} • {d.createdAt}
                      </div>
                    </td>
                    <td className="px-3 py-3 text-xs" data-id="element-5488">{d.buyerName}</td>
                    <td className="px-3 py-3" data-id="element-5489">
                      <div className="text-xs text-slate-900" data-id="element-5490">
                        {d.sellerName}
                      </div>
                      <div className="text-[10px] text-slate-500 line-clamp-1" data-id="element-5491">
                        {d.productTitle}
                      </div>
                    </td>
                    <td className="px-3 py-3 text-xs text-slate-700 max-w-xs line-clamp-2" data-id="element-5492">
                      {d.reason}
                    </td>
                    <td className="px-3 py-3 font-medium text-xs" data-id="element-5493">
                      {d.amount}
                    </td>
                    <td className="px-3 py-3" data-id="element-5494">{renderStatusBadge(d.status)}</td>
                    <td className="px-3 py-3 text-right" data-id="element-5495">
                      {d.status === 'open' || d.status === 'in_review' ? <div className="flex flex-col gap-1 items-end" data-id="element-5496">
                          <Button size="sm" variant="outline" className="text-[10px] w-full" onClick={() => handleResolveDispute(d.id, 'resolved_buyer')} data-id="element-5497">
                            → Покупателю
                          </Button>
                          <Button size="sm" variant="outline" className="text-[10px] w-full" onClick={() => handleResolveDispute(d.id, 'resolved_seller')} data-id="element-5498">
                            → Продавцу
                          </Button>
                        </div> : <span className="text-xs text-slate-400" data-id="element-5499">
                          {d.resolvedAt}
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {totalDisputePages > 1 && <Pagination currentPage={disputesPage} totalPages={totalDisputePages} onPageChange={setDisputesPage} data-id="element-5500" />}
      </div>;
  };
  // ========== ACCESS (WITH PAGINATION) ==========
  const renderAccess = () => {
    const totalAccessPages = Math.ceil(filteredAccess.length / ITEMS_PER_PAGE);
    const paginatedAccess = filteredAccess.slice((accessPage - 1) * ITEMS_PER_PAGE, accessPage * ITEMS_PER_PAGE);
    return <div className="space-y-4" data-id="element-5501">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4" data-id="element-5502">
          <div className="relative flex-1 max-w-md" data-id="element-5503">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-5504" />
            <Input placeholder="Поиск по пользователю или товару..." value={accessSearch} onChange={e => {
            setAccessSearch(e.target.value);
            setAccessPage(1);
          }} className="pl-9" data-id="element-5505" />
          </div>
          <span className="text-xs text-slate-500 self-end" data-id="element-5506">
            Найдено: {filteredAccess.length}
          </span>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5507">
          <div className="overflow-x-auto" data-id="element-5508">
            <table className="w-full text-left text-sm" data-id="element-5509">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5510">
                <tr data-id="element-5511">
                  <th className="px-4 py-3 font-medium" data-id="element-5512">Пользователь</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5513">Товар</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5514">Тип</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5515">Доступ</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5516">Выдан</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5517">Истекает</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5518">Скачиваний</th>
                  <th className="px-4 py-3 font-medium text-right" data-id="element-5519">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5520">
                {paginatedAccess.map(a => <tr key={a.id} className="hover:bg-slate-50" data-id="element-5521">
                    <td className="px-4 py-3" data-id="element-5522">
                      <div className="font-medium text-slate-900 text-xs" data-id="element-5523">
                        {a.userName}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-5524">
                        {a.userId}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-700 line-clamp-1" data-id="element-5525">
                      {a.productTitle}
                    </td>
                    <td className="px-4 py-3" data-id="element-5526">
                      <Badge variant="neutral" size="sm" className="capitalize text-[10px]" data-id="element-5527">
                        {a.type}
                      </Badge>
                    </td>
                    <td className="px-4 py-3" data-id="element-5528">
                      {renderStatusBadge(a.accessStatus)}
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-500" data-id="element-5529">
                      {a.grantedAt}
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-500" data-id="element-5530">
                      {a.expiresAt}
                    </td>
                    <td className="px-4 py-3 text-xs" data-id="element-5531">{a.downloads}</td>
                    <td className="px-4 py-3 text-right" data-id="element-5532">
                      <div className="flex items-center justify-end gap-1" data-id="element-5533">
                        {a.accessStatus === 'granted' && iconBtn(<Lock className="w-4 h-4" data-id="element-5534" />, 'Отозвать', () => handleRevokeAccess(a.id), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                        {a.accessStatus !== 'granted' && iconBtn(<Unlock className="w-4 h-4" data-id="element-5535" />, 'Открыть', () => handleGrantAccess(a.id), 'text-slate-400 hover:text-emerald-600 hover:bg-emerald-50')}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {totalAccessPages > 1 && <Pagination currentPage={accessPage} totalPages={totalAccessPages} onPageChange={setAccessPage} data-id="element-5536" />}
      </div>;
  };
  // ========== ANALYTICS ==========
  const renderAnalytics = () => <div className="space-y-6" data-id="element-5537">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-5538">
        <Card padding="md" className="bg-emerald-50/50 border-emerald-100" data-id="element-5539">
          <div className="text-sm text-slate-500" data-id="element-5540">Общий оборот</div>
          <div className="text-2xl font-bold text-emerald-700" data-id="element-5541">
            {kpis.totalRevenue.toLocaleString('ru-RU')} ₽
          </div>
        </Card>
        <Card padding="md" className="bg-indigo-50/50 border-indigo-100" data-id="element-5542">
          <div className="text-sm text-slate-500" data-id="element-5543">Комиссия платформы</div>
          <div className="text-2xl font-bold text-indigo-700" data-id="element-5544">
            {kpis.platformIncome.toLocaleString('ru-RU')} ₽
          </div>
        </Card>
        <Card padding="md" className="bg-sky-50/50 border-sky-100" data-id="element-5545">
          <div className="text-sm text-slate-500" data-id="element-5546">Средний чек</div>
          <div className="text-2xl font-bold text-sky-700" data-id="element-5547">
            {kpis.avgCheck.toLocaleString('ru-RU')} ₽
          </div>
        </Card>
        <Card padding="md" className="bg-amber-50/50 border-amber-100" data-id="element-5548">
          <div className="text-sm text-slate-500" data-id="element-5549">Конверсия</div>
          <div className="text-2xl font-bold text-amber-700" data-id="element-5550">
            {kpis.conversion}%
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-5551">
        <Card padding="md" data-id="element-5552">
          <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-5553">
            <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-5554" />
            Топ-5 товаров по продажам
          </h3>
          <div className="space-y-4" data-id="element-5555">
            {[...products].sort((a, b) => b.salesCount - a.salesCount).slice(0, 5).map((p, i) => {
            const maxSales = products.reduce((m, x) => Math.max(m, x.salesCount), 1);
            return <div key={p.id} data-id="element-5556">
                    <div className="flex justify-between text-sm mb-1" data-id="element-5557">
                      <span className="text-slate-700 truncate pr-4" data-id="element-5558">
                        {i + 1}. {p.title}
                      </span>
                      <span className="font-bold text-slate-900 flex-shrink-0" data-id="element-5559">
                        {p.salesCount} шт.
                      </span>
                    </div>
                    <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-5560">
                      <div className="bg-indigo-500 h-2 rounded-full" style={{
                  width: `${p.salesCount / maxSales * 100}%`
                }} data-id="element-5561" />
                    </div>
                  </div>;
          })}
          </div>
        </Card>
        <Card padding="md" data-id="element-5562">
          <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-5563">
            <Users className="w-5 h-5 text-indigo-500" data-id="element-5564" />
            Топ продавцов по доходу
          </h3>
          <div className="space-y-4" data-id="element-5565">
            {[...sellers].sort((a, b) => b.totalSales - a.totalSales).slice(0, 5).map((s, i) => <div key={s.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-5566">
                  <div className="flex items-center gap-3" data-id="element-5567">
                    <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold" data-id="element-5568">
                      {i + 1}
                    </div>
                    <div data-id="element-5569">
                      <div className="font-medium text-slate-900 text-sm" data-id="element-5570">
                        {s.name}
                      </div>
                      <div className="text-xs text-slate-500" data-id="element-5571">
                        {s.productsCount} товаров • ★ {s.rating}
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-5572">
                    <div className="font-bold text-emerald-600 text-sm" data-id="element-5573">
                      {s.totalRevenue}
                    </div>
                    <div className="text-[10px] text-slate-500" data-id="element-5574">
                      {s.totalSales} продаж
                    </div>
                  </div>
                </div>)}
          </div>
        </Card>
      </div>

      <Card padding="md" data-id="element-5575">
        <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-5576">
          <Bell className="w-5 h-5 text-indigo-500" data-id="element-5577" />
          Лог уведомлений
        </h3>
        <div className="overflow-x-auto" data-id="element-5578">
          <table className="w-full text-left text-sm" data-id="element-5579">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5580">
              <tr data-id="element-5581">
                <th className="px-3 py-2 font-medium" data-id="element-5582">Дата</th>
                <th className="px-3 py-2 font-medium" data-id="element-5583">Тип</th>
                <th className="px-3 py-2 font-medium" data-id="element-5584">Получатель</th>
                <th className="px-3 py-2 font-medium" data-id="element-5585">Сообщение</th>
                <th className="px-3 py-2 font-medium" data-id="element-5586">Канал</th>
                <th className="px-3 py-2 font-medium" data-id="element-5587">Статус</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-5588">
              {notifications.map(n => <tr key={n.id} className="hover:bg-slate-50" data-id="element-5589">
                  <td className="px-3 py-2 text-xs text-slate-500 whitespace-nowrap" data-id="element-5590">
                    {n.sentAt}
                  </td>
                  <td className="px-3 py-2" data-id="element-5591">
                    <Badge variant="neutral" size="sm" className="text-[10px]" data-id="element-5592">
                      {n.type}
                    </Badge>
                  </td>
                  <td className="px-3 py-2" data-id="element-5593">
                    <div className="text-xs font-medium text-slate-900" data-id="element-5594">
                      {n.recipientName}
                    </div>
                    <div className="text-[10px] text-slate-500 capitalize" data-id="element-5595">
                      {n.recipientType}
                    </div>
                  </td>
                  <td className="px-3 py-2 text-xs text-slate-700 max-w-md truncate" title={n.message} data-id="element-5596">
                    {n.message}
                  </td>
                  <td className="px-3 py-2 text-[10px] text-slate-500 uppercase" data-id="element-5597">
                    {n.channel}
                  </td>
                  <td className="px-3 py-2" data-id="element-5598">{renderStatusBadge(n.status)}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
  // ========== NEW TAB: COMPLAINTS ==========
  const renderComplaints = () => {
    const allComplaints = disputes.filter(d => d.status === 'open' || d.status === 'in_review');
    return <div className="space-y-4" data-id="element-5599">
        <div className="flex justify-between items-center mb-4" data-id="element-5600">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-5601">
            Жалобы и обращения
          </h3>
          <Badge variant={allComplaints.length > 0 ? 'error' : 'success'} data-id="element-5602">
            {allComplaints.length} активных
          </Badge>
        </div>
        {allComplaints.length === 0 ? <Card padding="xl" className="text-center" data-id="element-5603">
            <CheckCircle2 className="w-10 h-10 text-emerald-300 mx-auto mb-3" data-id="element-5604" />
            <div className="text-slate-500" data-id="element-5605">Нет активных жалоб</div>
          </Card> : <div className="space-y-3" data-id="element-5606">
            {allComplaints.map(d => <Card key={d.id} padding="md" className="border-rose-100" data-id="element-5607">
                <div className="flex items-start justify-between" data-id="element-5608">
                  <div data-id="element-5609">
                    <div className="flex items-center gap-2 mb-1" data-id="element-5610">
                      <AlertCircle className="w-4 h-4 text-rose-500" data-id="element-5611" />
                      <span className="font-bold text-slate-900 text-sm" data-id="element-5612">
                        {d.id}
                      </span>
                      {renderStatusBadge(d.status)}
                    </div>
                    <div className="text-xs text-slate-700 mb-1" data-id="element-5613">
                      <strong data-id="element-5614">Товар:</strong> {d.productTitle}
                    </div>
                    <div className="text-xs text-slate-600 mb-1" data-id="element-5615">
                      <strong data-id="element-5616">Покупатель:</strong> {d.buyerName} →{' '}
                      <strong data-id="element-5617">Продавец:</strong> {d.sellerName}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-5618">
                      {d.reason}
                    </div>
                    <div className="text-[10px] text-slate-400 mt-1" data-id="element-5619">
                      Сумма: {d.amount} • {d.createdAt}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 ml-4" data-id="element-5620">
                    <Button size="sm" variant="outline" className="text-[10px]" onClick={() => handleResolveDispute(d.id, 'resolved_buyer')} data-id="element-5621">
                      → Покупателю
                    </Button>
                    <Button size="sm" variant="outline" className="text-[10px]" onClick={() => handleResolveDispute(d.id, 'resolved_seller')} data-id="element-5622">
                      → Продавцу
                    </Button>
                    <Button size="sm" variant="ghost" className="text-[10px]" onClick={() => success(`Детали жалобы ${d.id}`)} data-id="element-5623">
                      Подробнее
                    </Button>
                  </div>
                </div>
              </Card>)}
          </div>}
      </div>;
  };
  // ========== NEW TAB: ARCHIVE ==========
  const renderArchive = () => {
    const archivedProducts = products.filter(p => p.status === 'archived');
    return <div className="space-y-4" data-id="element-5624">
        <div className="flex justify-between items-center mb-4" data-id="element-5625">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-5626">Архив товаров</h3>
          <span className="text-xs text-slate-500" data-id="element-5627">
            {archivedProducts.length} товаров в архиве
          </span>
        </div>
        {archivedProducts.length === 0 ? <Card padding="xl" className="text-center" data-id="element-5628">
            <Archive className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-5629" />
            <div className="text-slate-500" data-id="element-5630">Архив пуст</div>
          </Card> : <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-5631">
            <table className="w-full text-left text-sm" data-id="element-5632">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-5633">
                <tr data-id="element-5634">
                  <th className="px-4 py-3 font-medium" data-id="element-5635">Товар</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5636">Автор</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5637">Тип</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5638">Продажи</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5639">Доход</th>
                  <th className="px-4 py-3 font-medium" data-id="element-5640">Архивирован</th>
                  <th className="px-4 py-3 font-medium text-right" data-id="element-5641">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-5642">
                {archivedProducts.map(p => <tr key={p.id} className="hover:bg-slate-50" data-id="element-5643">
                    <td className="px-4 py-3" data-id="element-5644">
                      <div className="font-medium text-slate-900 text-xs" data-id="element-5645">
                        {p.title}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-5646">{p.id}</div>
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-700" data-id="element-5647">
                      {p.authorName}
                    </td>
                    <td className="px-4 py-3" data-id="element-5648">
                      <Badge variant="neutral" size="sm" className="capitalize text-[10px]" data-id="element-5649">
                        {p.type}
                      </Badge>
                    </td>
                    <td className="px-4 py-3 text-xs" data-id="element-5650">{p.salesCount} шт.</td>
                    <td className="px-4 py-3 text-xs text-emerald-600 font-medium" data-id="element-5651">
                      {p.revenue}
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-500" data-id="element-5652">
                      {p.updatedAt}
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-5653">
                      <div className="flex items-center justify-end gap-1" data-id="element-5654">
                        {iconBtn(<Eye className="w-4 h-4" data-id="element-5655" />, 'Просмотр', () => {
                    setActiveTab('products');
                    setSelectedProductId(p.id);
                    setDetailTab('info');
                  })}
                        {iconBtn(<RefreshCw className="w-4 h-4" data-id="element-5656" />, 'Восстановить', () => changeStatus(p.id, 'active', `${p.id} восстановлен из архива`), 'text-slate-400 hover:text-emerald-600 hover:bg-emerald-50')}
                        {iconBtn(<Trash2 className="w-4 h-4" data-id="element-5657" />, 'Удалить навсегда', () => success(`Удаление ${p.id} (подтверждение)`), 'text-slate-400 hover:text-rose-600 hover:bg-rose-50')}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>;
  };
  // ========== NEW TAB: PROBLEM PRODUCTS ==========
  const renderProblems = () => {
    const problemList = products.filter(p => {
      const pDisputes = disputes.filter(d => d.productId === p.id && (d.status === 'open' || d.status === 'in_review'));
      const pRefunds = orders.filter(o => o.productId === p.id && o.status === 'refunded');
      return p.rating > 0 && p.rating < 3.5 || pDisputes.length > 0 || pRefunds.length > 0;
    });
    return <div className="space-y-4" data-id="element-5658">
        <div className="flex justify-between items-center mb-4" data-id="element-5659">
          <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-5660">
            <AlertCircle className="w-5 h-5 text-rose-500" data-id="element-5661" /> Проблемные товары
          </h3>
          <Badge variant={problemList.length > 0 ? 'error' : 'success'} data-id="element-5662">
            {problemList.length} товаров
          </Badge>
        </div>
        {problemList.length === 0 ? <Card padding="xl" className="text-center" data-id="element-5663">
            <CheckCircle2 className="w-10 h-10 text-emerald-300 mx-auto mb-3" data-id="element-5664" />
            <div className="text-slate-500" data-id="element-5665">Проблемных товаров нет</div>
          </Card> : <div className="space-y-3" data-id="element-5666">
            {problemList.map(p => {
          const problems = getProductProblems(p);
          const money = getMoneyStatus(p);
          const pOrders = orders.filter(o => o.productId === p.id);
          const refundCount = pOrders.filter(o => o.status === 'refunded').length;
          const disputeCount = disputes.filter(d => d.productId === p.id && (d.status === 'open' || d.status === 'in_review')).length;
          return <Card key={p.id} padding="md" className="border-rose-200 bg-rose-50/30" data-id="element-5667">
                  <div className="flex items-start justify-between" data-id="element-5668">
                    <div className="flex items-start gap-3" data-id="element-5669">
                      <div className={`w-10 h-10 rounded-lg ${p.coverColor} flex items-center justify-center flex-shrink-0 relative`} data-id="element-5670">
                        <Package className="w-5 h-5 text-slate-700 opacity-50" data-id="element-5671" />
                        <span className="absolute -top-1 -right-1 w-4 h-4 bg-rose-500 rounded-full flex items-center justify-center text-white text-[8px] font-bold" data-id="element-5672">
                          !
                        </span>
                      </div>
                      <div data-id="element-5673">
                        <div className="font-bold text-slate-900 text-sm" data-id="element-5674">
                          {p.title}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5675">
                          {p.id} • {p.authorName}
                        </div>
                        <div className="flex flex-wrap gap-2 mt-2" data-id="element-5676">
                          {p.rating > 0 && p.rating < 3.5 && <span className="text-[10px] px-2 py-0.5 bg-rose-100 text-rose-700 rounded-full font-medium" data-id="element-5677">
                              ⭐ Рейтинг {p.rating}
                            </span>}
                          {disputeCount > 0 && <span className="text-[10px] px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full font-medium" data-id="element-5678">
                              ⚠ {disputeCount} спор(ов)
                            </span>}
                          {refundCount > 0 && <span className="text-[10px] px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full font-medium" data-id="element-5679">
                              🔄 {refundCount} возврат(ов)
                            </span>}
                          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${money.color} bg-slate-100`} data-id="element-5680">
                            {money.icon} {money.label}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 ml-4" data-id="element-5681">
                      <Button size="sm" variant="outline" onClick={() => {
                  setActiveTab('products');
                  setSelectedProductId(p.id);
                  setDetailTab('info');
                }} data-id="element-5682">
                        Открыть
                      </Button>
                      <Button size="sm" variant="outline" className="text-rose-600 border-rose-200" onClick={() => changeStatus(p.id, 'hidden', `${p.id} скрыт (проблемный)`)} data-id="element-5683">
                        Скрыть
                      </Button>
                    </div>
                  </div>
                </Card>;
        })}
          </div>}
      </div>;
  };
  // ========== TABS DEFINITION - EXPANDED ==========
  const tabs: {
    id: TabId;
    label: string;
    icon: any;
    count: number;
  }[] = [{
    id: 'products',
    label: 'Товары',
    icon: Package,
    count: products.length
  }, {
    id: 'sellers',
    label: 'Продавцы',
    icon: Users,
    count: sellers.length
  }, {
    id: 'orders',
    label: 'Заказы',
    icon: ShoppingBag,
    count: orders.length
  }, {
    id: 'payouts',
    label: 'Выплаты',
    icon: CreditCard,
    count: payouts.filter(p => p.status === 'pending').length
  }, {
    id: 'categories',
    label: 'Категории',
    icon: Folder,
    count: categories.length
  }, {
    id: 'reviews',
    label: 'Отзывы',
    icon: Star,
    count: reviews.filter(r => r.status === 'moderation').length
  }, {
    id: 'moderation',
    label: 'Модерация',
    icon: ShieldAlert,
    count: products.filter(p => p.status === 'moderation').length
  }, {
    id: 'disputes',
    label: 'Споры',
    icon: AlertTriangle,
    count: disputes.filter(d => d.status === 'open' || d.status === 'in_review').length
  }, {
    id: 'complaints',
    label: 'Жалобы',
    icon: AlertCircle,
    count: disputes.filter(d => d.status === 'open').length
  }, {
    id: 'access',
    label: 'Доступы',
    icon: Key,
    count: 0
  }, {
    id: 'archive',
    label: 'Архив',
    icon: Archive,
    count: products.filter(p => p.status === 'archived').length
  }, {
    id: 'problems',
    label: 'Проблемные',
    icon: AlertCircle,
    count: kpis.problemProducts
  }, {
    id: 'analytics',
    label: 'Аналитика',
    icon: BarChart3,
    count: 0
  }];
  return <div className="space-y-6" data-id="element-5684">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-5685">
        <div data-id="element-5686">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-5687">
            Маркетплейс — Центр управления
          </h2>
          <p className="text-slate-500 text-sm mt-1" data-id="element-5688">
            Товары • Продажи • Доступы • Финансы • AI • Реклама • Жалобы
          </p>
        </div>
        <div className="flex gap-2" data-id="element-5689">
          <Button variant={massSelectMode ? 'primary' : 'outline'} icon={<Search className="w-4 h-4" data-id="element-5691" />} onClick={() => {
          setMassSelectMode(!massSelectMode);
          if (massSelectMode) setSelectedProductIds(new Set());
        }} data-id="element-5690">
            {massSelectMode ? `Выбрано: ${selectedProductIds.size}` : 'Массовые'}
          </Button>
          <Button icon={<Plus className="w-4 h-4" data-id="element-5693" />} onClick={() => setShowCreateModal(true)} data-id="element-5692">
            + Создать товар
          </Button>
        </div>
      </div>

      {renderKpiRow()}

      <div className="flex border-b border-slate-200 overflow-x-auto scrollbar-hide" data-id="element-5694">
        {tabs.map(tab => <button key={tab.id} onClick={() => {
        setActiveTab(tab.id);
        setSelectedProductId(null);
      }} className={`flex items-center gap-1.5 px-3 py-3 border-b-2 font-medium text-xs whitespace-nowrap transition-colors ${activeTab === tab.id ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`} data-id="element-5695">
            <tab.icon className="w-3.5 h-3.5" data-id="element-5696" />
            {tab.label}
            {tab.count > 0 && <span className={`px-1.5 py-0.5 rounded-full text-[9px] ${activeTab === tab.id ? 'bg-indigo-100 text-indigo-700' : tab.id === 'problems' && tab.count > 0 ? 'bg-rose-100 text-rose-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-5697">
                {tab.count}
              </span>}
          </button>)}
      </div>

      <div className="pt-2" data-id="element-5698">
        {activeTab === 'products' && renderProducts()}
        {activeTab === 'sellers' && renderSellers()}
        {activeTab === 'orders' && renderOrders()}
        {activeTab === 'payouts' && renderPayouts()}
        {activeTab === 'categories' && renderCategories()}
        {activeTab === 'reviews' && renderReviews()}
        {activeTab === 'moderation' && renderModeration()}
        {activeTab === 'disputes' && renderDisputes()}
        {activeTab === 'complaints' && renderComplaints()}
        {activeTab === 'access' && renderAccess()}
        {activeTab === 'archive' && renderArchive()}
        {activeTab === 'problems' && renderProblems()}
        {activeTab === 'analytics' && renderAnalytics()}
      </div>

      {/* Create Product Modal */}
      {showCreateModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={() => setShowCreateModal(false)} data-id="element-5699">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-5700">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-slate-50" data-id="element-5701">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-5702">
                Создать товар
              </h3>
              <button onClick={() => setShowCreateModal(false)} className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-5703">
                <X className="w-5 h-5" data-id="element-5704" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-5705">
              <div data-id="element-5706">
                <label className="block text-xs font-medium text-slate-600 mb-1.5" data-id="element-5707">
                  Название товара *
                </label>
                <Input placeholder="Например: Курс по натальной карте" value={newProduct.title} onChange={e => setNewProduct(prev => ({
              ...prev,
              title: e.target.value
            }))} data-id="element-5708" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-5709">
                <div data-id="element-5710">
                  <label className="block text-xs font-medium text-slate-600 mb-1.5" data-id="element-5711">
                    Тип
                  </label>
                  <select className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" value={newProduct.type} onChange={e => setNewProduct(prev => ({
                ...prev,
                type: e.target.value
              }))} data-id="element-5712">
                    <option value="Курс" data-id="element-5713">Курс</option>
                    <option value="Гайд" data-id="element-5714">Гайд</option>
                    <option value="Марафон" data-id="element-5715">Марафон</option>
                    <option value="Pdf" data-id="element-5716">PDF</option>
                    <option value="Вебинар" data-id="element-5717">Вебинар</option>
                    <option value="Консультация" data-id="element-5718">Консультация</option>
                  </select>
                </div>
                <div data-id="element-5719">
                  <label className="block text-xs font-medium text-slate-600 mb-1.5" data-id="element-5720">
                    Цена (₽) *
                  </label>
                  <Input type="number" placeholder="4900" value={newProduct.price} onChange={e => setNewProduct(prev => ({
                ...prev,
                price: e.target.value
              }))} data-id="element-5721" />
                </div>
              </div>
              <div data-id="element-5722">
                <label className="block text-xs font-medium text-slate-600 mb-1.5" data-id="element-5723">
                  Автор (имя астролога)
                </label>
                <Input placeholder="Елена Смирнова" value={newProduct.authorName} onChange={e => setNewProduct(prev => ({
              ...prev,
              authorName: e.target.value
            }))} data-id="element-5724" />
              </div>
              <div data-id="element-5725">
                <label className="block text-xs font-medium text-slate-600 mb-1.5" data-id="element-5726">
                  Описание
                </label>
                <textarea className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none" rows={3} placeholder="Краткое описание товара..." value={newProduct.description} onChange={e => setNewProduct(prev => ({
              ...prev,
              description: e.target.value
            }))} data-id="element-5727" />
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50" data-id="element-5728">
              <Button variant="outline" onClick={() => setShowCreateModal(false)} data-id="element-5729">
                Отмена
              </Button>
              <Button onClick={handleCreateProduct} disabled={!newProduct.title.trim() || !newProduct.price.trim()} icon={<Plus className="w-4 h-4" data-id="element-5731" />} data-id="element-5730">
                Создать товар
              </Button>
            </div>
          </div>
        </div>}
    </div>;
}